// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAnyFeatureCatalogsClient {
  /**
   * Get all feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
  I.E. only feature catalogs with equal standard or custom feature catalogs based on such feature catalog are returned.
  This parameter can not be combined with the 'compatibleFcId' parameter.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this, or custom feature catalogs based on such feature catalog will be included in the returned list of feature catalogs.
  This parameter can not be combined with the 'compatibleFcId' parameter.
   * @param compatibleFcId (optional) Feature catalog ID of a feature catalog.
  If specified, only feature catalogs that are compatible with this feature catalog are returned.
  I.E. feature catalogs that has equal standard, equal major version and equal or greater minor version or custom
  feature catalogs that are based on such a feature catalog.
  This parameter can not be combined with the 'standard' or 'minimumVersion' parameters.
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of private feature catalogs
   */
  getAnyFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    compatibleFcId?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<AnyFeatureCatalog[]>

  /**
   * Get the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get
   * @return The feature catalog
   */
  getAnyFeatureCatalog(fcId: string): Promise<AnyFeatureCatalog>

  /**
   * Get information about the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get information about
   * @return The feature catalog information
   */
  getAnyFeatureCatalogInfo(fcId: string): Promise<AnyFeatureCatalogInfo>

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation>

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]>

  /**
   * Searches for types that contains the search string in its name or ID in the feature catalog with the specified ID
   * @param fcId ID of the feature catalog to search for types in
   * @param search The string to search for in type names and IDs
   * @param categories (optional) Specifies which type categories to search for. Multiple categories can be specified in a comma separated string.
  The possible type categories are FeatureTypeGroup, FeatureType, AttributeTypeGroup and AttributeType.
  Default is FeatureType,AttributeType
   * @param limit (optional) The maximum number of types to return. If zero (default), all matching types are returned
   * @param offset (optional) Zero based index of the first type in the total result set to be returned.
  Default is 0 (zero).
  Use this parameter to retrieve more matches if there are matches than returned due to limit.
   * @param language (optional) Specify language code for translated texts
   * @return Result object containing the types that matches the search criteria
   */
  searchForTypes(
    fcId: string,
    search: string | null,
    categories?: string | null | undefined,
    limit?: number | undefined,
    offset?: number | undefined,
    language?: string | null | undefined
  ): Promise<TypeSearchResult>

  /**
   * Get all available tags
   * @return List of Tag objects
   */
  getTags(): Promise<Tag[]>

  /**
   * List all feature type groups of the specified feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]>

  /**
   * Create a new feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgCreateRequest Information about the feature type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Feature Type Group
   */
  createFeatureTypeGroup(
    fcId: string,
    ftgCreateRequest: FeatureTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FeatureTypeGroup>

  /**
   * Get the specified feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended>

  /**
   * List all feature types in the specified feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * List all feature types in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * Create a new feature type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftCreateRequest Information about the feature type to create.
  The name will be compared with types in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Feature Type
   */
  createFeatureType(
    fcId: string,
    ftCreateRequest: FCFeatureTypeCreateRequest,
    fcEtag?: string | null | undefined
  ): Promise<FCFeatureType>

  /**
   * Get the specified feature type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
  and inherited attribute type (attribute type defined in inherited feature types)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType>

  /**
   * Get all attribute type groups in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]>

  /**
   * Create a new attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgCreateRequest Information about the attribute type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Attribute Type Group
   */
  createAttributeTypeGroup(
    fcId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * Get the specified attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * Get all attribute types in the specified attribute type group in the private feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(fcId: string, atgId: number, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Create a new attribute type in the specified attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId Id of attribute type group to place the attribute type into
   * @param atCreateRequest Information about the attribute type to create.
  The name will be compared with attribute types in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Attribute Type
   */
  createAttributeType(
    fcId: string,
    atgId: number,
    atCreateRequest: FCAttributeTypeCreateRequest,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeType>

  /**
   * Get all attribute types in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get the specified attribute type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType>
}

export class AnyFeatureCatalogsClient implements IAnyFeatureCatalogsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
  I.E. only feature catalogs with equal standard or custom feature catalogs based on such feature catalog are returned.
  This parameter can not be combined with the 'compatibleFcId' parameter.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this, or custom feature catalogs based on such feature catalog will be included in the returned list of feature catalogs.
  This parameter can not be combined with the 'compatibleFcId' parameter.
   * @param compatibleFcId (optional) Feature catalog ID of a feature catalog.
  If specified, only feature catalogs that are compatible with this feature catalog are returned.
  I.E. feature catalogs that has equal standard, equal major version and equal or greater minor version or custom
  feature catalogs that are based on such a feature catalog.
  This parameter can not be combined with the 'standard' or 'minimumVersion' parameters.
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of private feature catalogs
   */
  getAnyFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    compatibleFcId?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<AnyFeatureCatalog[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs?"
    if (standard !== undefined && standard !== null) url_ += "standard=" + encodeURIComponent("" + standard) + "&"
    if (minimumVersion !== undefined && minimumVersion !== null)
      url_ += "minimumVersion=" + encodeURIComponent("" + minimumVersion) + "&"
    if (compatibleFcId !== undefined && compatibleFcId !== null)
      url_ += "compatibleFcId=" + encodeURIComponent("" + compatibleFcId) + "&"
    if (maximumStreamVersion !== undefined && maximumStreamVersion !== null)
      url_ += "maximumStreamVersion=" + encodeURIComponent("" + maximumStreamVersion) + "&"
    if (tags !== undefined && tags !== null) url_ += "tags=" + encodeURIComponent("" + tags) + "&"
    if (excludeFcUri === null) throw new Error("The parameter 'excludeFcUri' cannot be null.")
    else if (excludeFcUri !== undefined) url_ += "excludeFcUri=" + encodeURIComponent("" + excludeFcUri) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnyFeatureCatalogs(_response)
    })
  }

  protected processGetAnyFeatureCatalogs(response: Response): Promise<AnyFeatureCatalog[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AnyFeatureCatalog[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AnyFeatureCatalog[]>(null as any)
  }

  /**
   * Get the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get
   * @return The feature catalog
   */
  getAnyFeatureCatalog(fcId: string): Promise<AnyFeatureCatalog> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnyFeatureCatalog(_response)
    })
  }

  protected processGetAnyFeatureCatalog(response: Response): Promise<AnyFeatureCatalog> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AnyFeatureCatalog)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AnyFeatureCatalog>(null as any)
  }

  /**
   * Get information about the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get information about
   * @return The feature catalog information
   */
  getAnyFeatureCatalogInfo(fcId: string): Promise<AnyFeatureCatalogInfo> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/info"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAnyFeatureCatalogInfo(_response)
    })
  }

  protected processGetAnyFeatureCatalogInfo(response: Response): Promise<AnyFeatureCatalogInfo> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AnyFeatureCatalogInfo)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AnyFeatureCatalogInfo>(null as any)
  }

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/status"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalogStatus(_response)
    })
  }

  protected processGetFeatureCatalogStatus(response: Response): Promise<FCStatusInformation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCStatusInformation)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCStatusInformation>(null as any)
  }

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/languages"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLanguages(_response)
    })
  }

  protected processGetLanguages(response: Response): Promise<Language[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Language[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Language[]>(null as any)
  }

  /**
   * Searches for types that contains the search string in its name or ID in the feature catalog with the specified ID
   * @param fcId ID of the feature catalog to search for types in
   * @param search The string to search for in type names and IDs
   * @param categories (optional) Specifies which type categories to search for. Multiple categories can be specified in a comma separated string.
  The possible type categories are FeatureTypeGroup, FeatureType, AttributeTypeGroup and AttributeType.
  Default is FeatureType,AttributeType
   * @param limit (optional) The maximum number of types to return. If zero (default), all matching types are returned
   * @param offset (optional) Zero based index of the first type in the total result set to be returned.
  Default is 0 (zero).
  Use this parameter to retrieve more matches if there are matches than returned due to limit.
   * @param language (optional) Specify language code for translated texts
   * @return Result object containing the types that matches the search criteria
   */
  searchForTypes(
    fcId: string,
    search: string | null,
    categories?: string | null | undefined,
    limit?: number | undefined,
    offset?: number | undefined,
    language?: string | null | undefined
  ): Promise<TypeSearchResult> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/types?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (search === undefined) throw new Error("The parameter 'search' must be defined.")
    else if (search !== null) url_ += "search=" + encodeURIComponent("" + search) + "&"
    if (categories !== undefined && categories !== null)
      url_ += "categories=" + encodeURIComponent("" + categories) + "&"
    if (limit === null) throw new Error("The parameter 'limit' cannot be null.")
    else if (limit !== undefined) url_ += "limit=" + encodeURIComponent("" + limit) + "&"
    if (offset === null) throw new Error("The parameter 'offset' cannot be null.")
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&"
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSearchForTypes(_response)
    })
  }

  protected processSearchForTypes(response: Response): Promise<TypeSearchResult> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TypeSearchResult)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<TypeSearchResult>(null as any)
  }

  /**
   * Get all available tags
   * @return List of Tag objects
   */
  getTags(): Promise<Tag[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/tags"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTags(_response)
    })
  }

  protected processGetTags(response: Response): Promise<Tag[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Tag[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Tag[]>(null as any)
  }

  /**
   * List all feature type groups of the specified feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroups(_response)
    })
  }

  protected processGetFeatureTypeGroups(response: Response): Promise<FeatureTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroup[]>(null as any)
  }

  /**
   * Create a new feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgCreateRequest Information about the feature type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Feature Type Group
   */
  createFeatureTypeGroup(
    fcId: string,
    ftgCreateRequest: FeatureTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FeatureTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypeGroups"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(ftgCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "fc-etag": fcEtag !== undefined && fcEtag !== null ? "" + fcEtag : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFeatureTypeGroup(_response)
    })
  }

  protected processCreateFeatureTypeGroup(response: Response): Promise<FeatureTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroup)
        return result201
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The create request could not be executed due to eTag mismatch or duplicate name or duplicate ID",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroup>(null as any)
  }

  /**
   * Get the specified feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroup(_response)
    })
  }

  protected processGetFeatureTypeGroup(response: Response): Promise<FeatureTypeGroupExtended> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroupExtended)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroupExtended>(null as any)
  }

  /**
   * List all feature types in the specified feature type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypesInGroup(_response)
    })
  }

  protected processGetFeatureTypesInGroup(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * List all feature types in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypes(_response)
    })
  }

  protected processGetFeatureTypes(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * Create a new feature type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftCreateRequest Information about the feature type to create.
  The name will be compared with types in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Feature Type
   */
  createFeatureType(
    fcId: string,
    ftCreateRequest: FCFeatureTypeCreateRequest,
    fcEtag?: string | null | undefined
  ): Promise<FCFeatureType> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypes"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(ftCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "fc-etag": fcEtag !== undefined && fcEtag !== null ? "" + fcEtag : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFeatureType(_response)
    })
  }

  protected processCreateFeatureType(response: Response): Promise<FCFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCFeatureType)
        return result201
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The create request could not be executed due to eTag mismatch or duplicate name or duplicate ID",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCFeatureType>(null as any)
  }

  /**
   * Get the specified feature type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
  and inherited attribute type (attribute type defined in inherited feature types)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/featureTypes/{ftId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    if (includeInheritance === null) throw new Error("The parameter 'includeInheritance' cannot be null.")
    else if (includeInheritance !== undefined)
      url_ += "includeInheritance=" + encodeURIComponent("" + includeInheritance) + "&"
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureType(_response)
    })
  }

  protected processGetFeatureType(response: Response): Promise<FCFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCFeatureType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCFeatureType>(null as any)
  }

  /**
   * Get all attribute type groups in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroups(_response)
    })
  }

  protected processGetAttributeTypeGroups(response: Response): Promise<FCAttributeTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup[]>(null as any)
  }

  /**
   * Create a new attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgCreateRequest Information about the attribute type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Attribute Type Group
   */
  createAttributeTypeGroup(
    fcId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypeGroups"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atgCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "fc-etag": fcEtag !== undefined && fcEtag !== null ? "" + fcEtag : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateAttributeTypeGroup(_response)
    })
  }

  protected processCreateAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result201
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The create request could not be executed due to eTag mismatch or duplicate name or duplicate ID",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * Get the specified attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroup(_response)
    })
  }

  protected processGetAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * Get all attribute types in the specified attribute type group in the private feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesInGroup(_response)
    })
  }

  protected processGetAttributeTypesInGroup(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Create a new attribute type in the specified attribute type group in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atgId Id of attribute type group to place the attribute type into
   * @param atCreateRequest Information about the attribute type to create.
  The name will be compared with attribute types in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the feature catalog
   * @return The new Attribute Type
   */
  createAttributeType(
    fcId: string,
    atgId: number,
    atCreateRequest: FCAttributeTypeCreateRequest,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeType> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}/attributeTypes"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "fc-etag": fcEtag !== undefined && fcEtag !== null ? "" + fcEtag : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateAttributeType(_response)
    })
  }

  protected processCreateAttributeType(response: Response): Promise<FCAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeType)
        return result201
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The create request could not be executed due to eTag mismatch or duplicate name or duplicate ID",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeType>(null as any)
  }

  /**
   * Get all attribute types in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypes(_response)
    })
  }

  protected processGetAttributeTypes(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get the specified attribute type in the specified feature catalog
   * @param fcId ID of the feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType> {
    let url_ = this.baseUrl + "/api/v2/anyFeatureCatalogs/{fcId}/attributeTypes/{atId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeType(_response)
    })
  }

  protected processGetAttributeType(response: Response): Promise<FCAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeType>(null as any)
  }
}

export interface ICDMLibraryClient {
  /**
   * Get all the propertysets from the cdm libraries from the Trimble Connect projects where the user is a member of
   * @return Get all propertysets of the user
   */
  getCDMPropertySets(): Promise<CDMPropertySet[]>

  /**
   * Get properties of a propertyset
   * @return Get all propertyset properties of a property set
   */
  getCDMPropertySetProperties(propertySetId: string): Promise<CDMPropertySetProperty[]>
}

export class CDMLibraryClient implements ICDMLibraryClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all the propertysets from the cdm libraries from the Trimble Connect projects where the user is a member of
   * @return Get all propertysets of the user
   */
  getCDMPropertySets(): Promise<CDMPropertySet[]> {
    let url_ = this.baseUrl + "/api/v2/cdmPropertySets"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCDMPropertySets(_response)
    })
  }

  protected processGetCDMPropertySets(response: Response): Promise<CDMPropertySet[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CDMPropertySet[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CDMPropertySet[]>(null as any)
  }

  /**
   * Get properties of a propertyset
   * @return Get all propertyset properties of a property set
   */
  getCDMPropertySetProperties(propertySetId: string): Promise<CDMPropertySetProperty[]> {
    let url_ = this.baseUrl + "/api/v2/cdmPropertySets/{propertySetId}/cdmPropertySetProperties"
    if (propertySetId === undefined || propertySetId === null)
      throw new Error("The parameter 'propertySetId' must be defined.")
    url_ = url_.replace("{propertySetId}", encodeURIComponent("" + propertySetId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCDMPropertySetProperties(_response)
    })
  }

  protected processGetCDMPropertySetProperties(response: Response): Promise<CDMPropertySetProperty[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CDMPropertySetProperty[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CDMPropertySetProperty[]>(null as any)
  }
}

export interface IClassificationsClient {
  /**
   * Get all classifications that the authenticated user has access to
   * @return The list of classifications
   */
  getAccessibleClassifications(): Promise<Classification[]>

  /**
   * Get a specific classification
   * @param cId Id of the classification to get
   * @return The full classification structure
   */
  getClassification(cId: string): Promise<ClassificationFullOfClassificationCategoryExtended>

  /**
   * Delete the specified classification
   * @param cId Id of the classification to delete
   * @return Classification successfully deleted.
   */
  deleteClassification(cId: string): Promise<void>

  /**
   * Imports a classification structure from Svensk byggtjänst and converts it to a generic classification structure
   * @param coClassCreateRequest Parameters needed for contacting Svensk byggtjänst
   * @return The new classification
   */
  createClassificationFromCoClassService(coClassCreateRequest: CoClassCreateRequest): Promise<Classification>

  /**
   * Re-imports a classification structure from Svensk byggtjänst, converts it to a generic classification structure
  and replaces the classification with the specified ID
   * @param cId Id of the classification to refresh
   * @return The updated classification structure
   */
  refreshClassificationFromCoClassService(cId: string): Promise<Classification>
}

export class ClassificationsClient implements IClassificationsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all classifications that the authenticated user has access to
   * @return The list of classifications
   */
  getAccessibleClassifications(): Promise<Classification[]> {
    let url_ = this.baseUrl + "/api/v2/classifications"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAccessibleClassifications(_response)
    })
  }

  protected processGetAccessibleClassifications(response: Response): Promise<Classification[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Classification[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Classification[]>(null as any)
  }

  /**
   * Get a specific classification
   * @param cId Id of the classification to get
   * @return The full classification structure
   */
  getClassification(cId: string): Promise<ClassificationFullOfClassificationCategoryExtended> {
    let url_ = this.baseUrl + "/api/v2/classifications/{cId}"
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClassification(_response)
    })
  }

  protected processGetClassification(response: Response): Promise<ClassificationFullOfClassificationCategoryExtended> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationFullOfClassificationCategoryExtended)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The classification with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationFullOfClassificationCategoryExtended>(null as any)
  }

  /**
   * Delete the specified classification
   * @param cId Id of the classification to delete
   * @return Classification successfully deleted.
   */
  deleteClassification(cId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/classifications/{cId}"
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClassification(_response)
    })
  }

  protected processDeleteClassification(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("The classification was not found.", status, _responseText, _headers, result404)
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The classification cannot be deleted because it is in use.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Imports a classification structure from Svensk byggtjänst and converts it to a generic classification structure
   * @param coClassCreateRequest Parameters needed for contacting Svensk byggtjänst
   * @return The new classification
   */
  createClassificationFromCoClassService(coClassCreateRequest: CoClassCreateRequest): Promise<Classification> {
    let url_ = this.baseUrl + "/api/v2/classifications/coclass"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(coClassCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClassificationFromCoClassService(_response)
    })
  }

  protected processCreateClassificationFromCoClassService(response: Response): Promise<Classification> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Classification)
        return result201
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Classification>(null as any)
  }

  /**
   * Re-imports a classification structure from Svensk byggtjänst, converts it to a generic classification structure
  and replaces the classification with the specified ID
   * @param cId Id of the classification to refresh
   * @return The updated classification structure
   */
  refreshClassificationFromCoClassService(cId: string): Promise<Classification> {
    let url_ = this.baseUrl + "/api/v2/classifications/{cId}/coclass"
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "PATCH",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRefreshClassificationFromCoClassService(_response)
    })
  }

  protected processRefreshClassificationFromCoClassService(response: Response): Promise<Classification> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Classification)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The classification with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "Can not refresh a non CoClass classification with this method",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Classification>(null as any)
  }
}

export interface IConversionRulesClient {
  /**
   * Get all conversion rules that the authenticated user has access to
   * @return The list of conversion rules
   */
  getConversionRules(): Promise<ConversionRule[]>

  /**
   * Create a new conversion rule
   * @param crCreateRequest Information about the conversion rule to create
   * @return The newly created conversion rule
   */
  createConversionRule(crCreateRequest: ConversionRuleCreateRequest): Promise<ConversionRule>

  /**
   * Get the conversion rule with the specified ID
   * @param crId ID of the conversion rule to get
   * @return Conversion Rule
   */
  getConversionRule(crId: string): Promise<ConversionRule>

  /**
   * Update the conversion rule with the specified ID
   * @param crId ID of the conversion rule to update
   * @param crUpdateRequest The new values to be used for the conversion rule
   * @return The newly updated conversion rule.
   */
  updateConversionRule(crId: string, crUpdateRequest: ConversionRuleUpdateRequest): Promise<ConversionRule>

  /**
   * Delete the conversion rule with the specified ID
   * @param crId ID of the conversion rule to remove
   * @return Conversion Rule successfully removed.
   */
  deleteConversionRule(crId: string): Promise<void>
}

export class ConversionRulesClient implements IConversionRulesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all conversion rules that the authenticated user has access to
   * @return The list of conversion rules
   */
  getConversionRules(): Promise<ConversionRule[]> {
    let url_ = this.baseUrl + "/api/v2/conversionRules"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetConversionRules(_response)
    })
  }

  protected processGetConversionRules(response: Response): Promise<ConversionRule[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ConversionRule[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ConversionRule[]>(null as any)
  }

  /**
   * Create a new conversion rule
   * @param crCreateRequest Information about the conversion rule to create
   * @return The newly created conversion rule
   */
  createConversionRule(crCreateRequest: ConversionRuleCreateRequest): Promise<ConversionRule> {
    let url_ = this.baseUrl + "/api/v2/conversionRules"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(crCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateConversionRule(_response)
    })
  }

  protected processCreateConversionRule(response: Response): Promise<ConversionRule> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ConversionRule)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ConversionRule>(null as any)
  }

  /**
   * Get the conversion rule with the specified ID
   * @param crId ID of the conversion rule to get
   * @return Conversion Rule
   */
  getConversionRule(crId: string): Promise<ConversionRule> {
    let url_ = this.baseUrl + "/api/v2/conversionRules/{crId}"
    if (crId === undefined || crId === null) throw new Error("The parameter 'crId' must be defined.")
    url_ = url_.replace("{crId}", encodeURIComponent("" + crId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetConversionRule(_response)
    })
  }

  protected processGetConversionRule(response: Response): Promise<ConversionRule> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ConversionRule)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The conversion rule with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ConversionRule>(null as any)
  }

  /**
   * Update the conversion rule with the specified ID
   * @param crId ID of the conversion rule to update
   * @param crUpdateRequest The new values to be used for the conversion rule
   * @return The newly updated conversion rule.
   */
  updateConversionRule(crId: string, crUpdateRequest: ConversionRuleUpdateRequest): Promise<ConversionRule> {
    let url_ = this.baseUrl + "/api/v2/conversionRules/{crId}"
    if (crId === undefined || crId === null) throw new Error("The parameter 'crId' must be defined.")
    url_ = url_.replace("{crId}", encodeURIComponent("" + crId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(crUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateConversionRule(_response)
    })
  }

  protected processUpdateConversionRule(response: Response): Promise<ConversionRule> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ConversionRule)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The conversion rule with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ConversionRule>(null as any)
  }

  /**
   * Delete the conversion rule with the specified ID
   * @param crId ID of the conversion rule to remove
   * @return Conversion Rule successfully removed.
   */
  deleteConversionRule(crId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/conversionRules/{crId}"
    if (crId === undefined || crId === null) throw new Error("The parameter 'crId' must be defined.")
    url_ = url_.replace("{crId}", encodeURIComponent("" + crId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteConversionRule(_response)
    })
  }

  protected processDeleteConversionRule(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The conversion rule with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }
}

export interface ICustomFeatureCatalogsClient {
  /**
   * Get all custom feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field i.e. only feature catalogs with this standard
  or feature catalogs based on a feature catalog with this standard are included.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of custom feature catalogs
   */
  getCustomFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<CustomFeatureCatalog[]>

  /**
   * Publish a new custom feature catalog based on the specified feature catalog customization version.
   * @param fccReference A reference to the feature catalog customization (and version) to publish.
   * @return Reference to the custom feature catalog that are under construction
   */
  publishCustomFeatureCatalog(fccReference: FCCustomizationReference): Promise<CustomFeatureCatalogSimple>

  /**
   * Get the custom feature catalog with the specified ID.
   * @param fcId Id of the custom feature catalog to get.
   * @return The custom feature catalog
   */
  getCustomFeatureCatalog(fcId: string): Promise<CustomFeatureCatalog>

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation>

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]>

  /**
   * Get a reference to the feature catalog customization version that was used to create
             the custom feature catalog with the specified ID.
   * @param fcId The ID (persistent id) of the custom feature catalog.
   * @return Reference to the feature catalog customization used to create the feature catalog
   */
  getCustomizationReferenceByFcId(fcId: number): Promise<FCCustomizationReference>

  /**
   * Schedule data production for the specified custom feature catalog
   * @param fcId Id of the custom feature catalog to produce type data for.
   * @return Data production for the specified custom feature catalog is scheduled
   */
  produceTypeDataForCustomFeatureCatalog(fcId: string): Promise<void>

  /**
   * List all feature type groups of the specified custom feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]>

  /**
   * Get the specified feature type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended>

  /**
   * List all feature types in the specified feature type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * List all feature types in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * Get the specified feature type in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType>

  /**
   * Get all attribute type groups in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]>

  /**
   * Get the specified attribute type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * Get all attribute types in the specified attribute type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(fcId: string, atgId: number, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get all attribute types in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get the specified attribute type in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType>
}

export class CustomFeatureCatalogsClient implements ICustomFeatureCatalogsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all custom feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field i.e. only feature catalogs with this standard
  or feature catalogs based on a feature catalog with this standard are included.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of custom feature catalogs
   */
  getCustomFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<CustomFeatureCatalog[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs?"
    if (standard !== undefined && standard !== null) url_ += "standard=" + encodeURIComponent("" + standard) + "&"
    if (minimumVersion !== undefined && minimumVersion !== null)
      url_ += "minimumVersion=" + encodeURIComponent("" + minimumVersion) + "&"
    if (maximumStreamVersion !== undefined && maximumStreamVersion !== null)
      url_ += "maximumStreamVersion=" + encodeURIComponent("" + maximumStreamVersion) + "&"
    if (tags !== undefined && tags !== null) url_ += "tags=" + encodeURIComponent("" + tags) + "&"
    if (excludeFcUri === null) throw new Error("The parameter 'excludeFcUri' cannot be null.")
    else if (excludeFcUri !== undefined) url_ += "excludeFcUri=" + encodeURIComponent("" + excludeFcUri) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomFeatureCatalogs(_response)
    })
  }

  protected processGetCustomFeatureCatalogs(response: Response): Promise<CustomFeatureCatalog[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureCatalog[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureCatalog[]>(null as any)
  }

  /**
   * Publish a new custom feature catalog based on the specified feature catalog customization version.
   * @param fccReference A reference to the feature catalog customization (and version) to publish.
   * @return Reference to the custom feature catalog that are under construction
   */
  publishCustomFeatureCatalog(fccReference: FCCustomizationReference): Promise<CustomFeatureCatalogSimple> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(fccReference)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPublishCustomFeatureCatalog(_response)
    })
  }

  protected processPublishCustomFeatureCatalog(response: Response): Promise<CustomFeatureCatalogSimple> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureCatalogSimple)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified version of the feature catalog customization can not be published (already published).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog could not be published due to an edit conflict on the feature catalog customization.",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureCatalogSimple>(null as any)
  }

  /**
   * Get the custom feature catalog with the specified ID.
   * @param fcId Id of the custom feature catalog to get.
   * @return The custom feature catalog
   */
  getCustomFeatureCatalog(fcId: string): Promise<CustomFeatureCatalog> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomFeatureCatalog(_response)
    })
  }

  protected processGetCustomFeatureCatalog(response: Response): Promise<CustomFeatureCatalog> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureCatalog)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The custom feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureCatalog>(null as any)
  }

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/status"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalogStatus(_response)
    })
  }

  protected processGetFeatureCatalogStatus(response: Response): Promise<FCStatusInformation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCStatusInformation)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCStatusInformation>(null as any)
  }

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/languages"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLanguages(_response)
    })
  }

  protected processGetLanguages(response: Response): Promise<Language[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Language[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Language[]>(null as any)
  }

  /**
   * Get a reference to the feature catalog customization version that was used to create
             the custom feature catalog with the specified ID.
   * @param fcId The ID (persistent id) of the custom feature catalog.
   * @return Reference to the feature catalog customization used to create the feature catalog
   */
  getCustomizationReferenceByFcId(fcId: number): Promise<FCCustomizationReference> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/customizationReferences"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetCustomizationReferenceByFcId(_response)
    })
  }

  protected processGetCustomizationReferenceByFcId(response: Response): Promise<FCCustomizationReference> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationReference)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The custom feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationReference>(null as any)
  }

  /**
   * Schedule data production for the specified custom feature catalog
   * @param fcId Id of the custom feature catalog to produce type data for.
   * @return Data production for the specified custom feature catalog is scheduled
   */
  produceTypeDataForCustomFeatureCatalog(fcId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/data"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "PATCH",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processProduceTypeDataForCustomFeatureCatalog(_response)
    })
  }

  protected processProduceTypeDataForCustomFeatureCatalog(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The custom feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          "The custom feature catalog with the specified ID is not published yet.",
          status,
          _responseText,
          _headers
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * List all feature type groups of the specified custom feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/featureTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroups(_response)
    })
  }

  protected processGetFeatureTypeGroups(response: Response): Promise<FeatureTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroup[]>(null as any)
  }

  /**
   * Get the specified feature type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroup(_response)
    })
  }

  protected processGetFeatureTypeGroup(response: Response): Promise<FeatureTypeGroupExtended> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroupExtended)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroupExtended>(null as any)
  }

  /**
   * List all feature types in the specified feature type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypesInGroup(_response)
    })
  }

  protected processGetFeatureTypesInGroup(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * List all feature types in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypes(_response)
    })
  }

  protected processGetFeatureTypes(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * Get the specified feature type in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/featureTypes/{ftId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    if (includeInheritance === null) throw new Error("The parameter 'includeInheritance' cannot be null.")
    else if (includeInheritance !== undefined)
      url_ += "includeInheritance=" + encodeURIComponent("" + includeInheritance) + "&"
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureType(_response)
    })
  }

  protected processGetFeatureType(response: Response): Promise<FCFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCFeatureType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCFeatureType>(null as any)
  }

  /**
   * Get all attribute type groups in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/attributeTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroups(_response)
    })
  }

  protected processGetAttributeTypeGroups(response: Response): Promise<FCAttributeTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup[]>(null as any)
  }

  /**
   * Get the specified attribute type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroup(_response)
    })
  }

  protected processGetAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * Get all attribute types in the specified attribute type group in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesInGroup(_response)
    })
  }

  protected processGetAttributeTypesInGroup(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get all attribute types in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypes(_response)
    })
  }

  protected processGetAttributeTypes(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get the specified attribute type in the specified custom feature catalog
   * @param fcId ID of the custom feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType> {
    let url_ = this.baseUrl + "/api/v2/customFeatureCatalogs/{fcId}/attributeTypes/{atId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeType(_response)
    })
  }

  protected processGetAttributeType(response: Response): Promise<FCAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeType>(null as any)
  }
}

export interface IFCCustomizationsClient {
  /**
   * Create a new feature catalog customization
   * @param fccCreateRequest The data of the new feature catalog customization in JSON format
   * @return The newly created feature catalog customization
   */
  createFCCustomization(fccCreateRequest: FCCustomizationCreateRequest): Promise<FCCustomizationCombined>

  /**
   * Get all feature catalog customizations that the authenticated user has access to
   * @return The list of feature catalog customizations
   */
  getFCCustomizations(): Promise<FCCustomization[]>

  /**
   * Get a specific feature catalog customization id
   * @param fccId Id of the feature catalog customization to get
   * @return The feature catalog customization info
   */
  getFCCustomization(fccId: string): Promise<FCCustomizationCombined>

  /**
   * Updates the feature catalog customization by id
   * @param fccId ID of the feature catalog customization to update
   * @param fccUpdateRequest FCCustomizationUpdateRequest containing the new values.
   * @return The successfully updated feature catalog customization
   */
  updateFCCustomization(fccId: string, fccUpdateRequest: FCCustomizationUpdateRequest): Promise<FCCustomizationCombined>

  /**
   * Remove the current version of the feature catalog customization with the specified id
   * @param fccId Id of the feature catalog customization to remove
   * @return Feature Catalog Customization successfully deleted.
   */
  deleteFCCustomization(fccId: string): Promise<void>

  /**
   * Exports the specified feature catalog customization as an Excel file
   * @param fccId Id of the feature catalog customization to export
   * @param includeIds (optional) Set to true in order to include ID column in the sheets. Default is false
   * @param valueSeparator (optional) Character to be used to separate multiple values in a cell. Default is pipe |
   * @return Excel file containing the types of the the feature catalog customization
   */
  exportFCCustomizationToExcel(
    fccId: string,
    includeIds?: boolean | undefined,
    valueSeparator?: string | null | undefined
  ): Promise<FileResponse>

  /**
   * Starts a process to import content to the specified feature catalog customization from an excel file.
   * @param fccId ID of the feature catalog customization to import into
   * @param excelFile (optional)
   * @return Information about the import process started
   */
  importFCCustomizationFromExcel(
    fccId: string,
    excelFile?: FileParameter | null | undefined
  ): Promise<FCCustomizationImportProgress>

  /**
   * Get progress and status of the specified import process to the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization
   * @param ticketId ID (ticket) of the import process
   * @return The content of the excel file was successfully imported into the feature catalog customization
   */
  getFccImportProgress(fccId: string, ticketId: string): Promise<FCCustomizationImportProgress>

  /**
   * Get all versions of the specified feature catalog customization
   * @return The list of feature catalog customization versions
   */
  getFCCustomizationVersions(fccId: string): Promise<FCCustomizationCombined[]>

  /**
   * Create a new version of the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to make a new version of
   * @param fccCreateRequest The data of the new feature catalog customization version in JSON format
   * @return The newly created version of the feature catalog customization
   */
  createFCCustomizationVersion(
    fccId: string,
    fccCreateRequest: FCCustomizationCreateRequest
  ): Promise<FCCustomizationCombined>

  /**
   * Get a specific feature catalog customization version by id and version
   * @param fccId Id of the feature catalog customization to get
   * @param fccVersionNumber Version number for the feature catalog customization version to get.
   * @return The feature catalog customization version
   */
  getFCCustomizationVersion(fccId: string, fccVersionNumber: number): Promise<FCCustomizationCombined>

  /**
   * Gets all user roles for the specified feature catalog customization i.e. who has access to the customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @return List of user roles
   */
  getUserRoles(fccId: string): Promise<UserRole[]>

  /**
   * Adds a user role to the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @param userRoleCreateRequest Role and user information for the new user role
   * @return User role successfully removed.
   */
  createUserRole(fccId: string, userRoleCreateRequest: UserRoleCreateRequest): Promise<UserRole>

  /**
   * Gets the specified user role for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to get
   * @return User role
   */
  getUserRole(fccId: string, userIdOrEmail: string): Promise<UserRole>

  /**
   * Update the specified user role for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to update user role for
   * @param userIdOrEmail Id or e-mail of user in the user role to update
   * @param updateRequest New Role
   * @return User role successfully updated.
   */
  updateUserRole(fccId: string, userIdOrEmail: string, updateRequest: UserRoleUpdateRequest): Promise<UserRole>

  /**
   * Remove the specified user role from the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to remove user roles from
   * @param userIdOrEmail Id or e-mail of user in the user role to remove
   * @return User role successfully removed.
   */
  deleteUserRole(fccId: string, userIdOrEmail: string): Promise<void>

  /**
   * Get a reference to all classifications associated with the current version of the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get classifications for
   * @return The list of classifications
   */
  getClassificationsFromCurrentVersion(fccId: string): Promise<ClassificationHeader[]>

  /**
   * Get a reference to all classifications associated with the specified feature catalog customization and version
   * @param fccId Id of the feature catalog customization to get classifications for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classifications for.
   * @return The list of classifications
   */
  getClassifications(fccId: string, fccVersionNumber: number): Promise<ClassificationHeader[]>

  /**
   * Add usage of the specified classification to the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param classificationReference Reference to an existing classification and category to attribute type mapping
   * @return The classification reference added
   */
  createClassificationUsage(
    fccId: string,
    fccVersionNumber: number,
    classificationReference: ClassificationReference
  ): Promise<ClassificationReference>

  /**
   * Get the specified complete classification structure with category to attribute type mapping in the current version
             of the feature catalog customization
   * @param fccId Id of the feature catalog customization to get classification for
   * @param cId Id of the classification structure to get
   * @return The list of classifications
   */
  getFullClassificationFromCurrentVersion(fccId: string, cId: string): Promise<ClassificationHeader[]>

  /**
   * Get the specified complete classification structure with category to attribute type mapping
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param cId Id of the classification structure to get
   * @return The full classification structure
   */
  getFullClassification(
    fccId: string,
    fccVersionNumber: number,
    cId: string
  ): Promise<ClassificationFullOfCategoryToAttributeConnectionExtended[]>

  /**
   * Update usage of the specified classification in the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param cId Id of the classification structure to update reference to
   * @param classificationReference Reference to an existing classification and category to attribute type mapping
   * @return The updated classification reference
   */
  updateClassificationUsage(
    fccId: string,
    fccVersionNumber: number,
    cId: string,
    classificationReference: ClassificationReference
  ): Promise<ClassificationReference>

  /**
   * Remove the usage of the specified classification from the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to remove classification usage from
   * @param fccVersionNumber Version number for the feature catalog customization version to remove classification usage from.
   * @param cId Id of the classification to remove usage of
   * @return Classification reference successfully removed
   */
  deleteClassificationUsage(fccId: string, fccVersionNumber: number, cId: string): Promise<void>

  /**
   * Get all attribute type groups defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get attribute type groups for
   * @return The list of attribute type groups
   */
  getAttributeTypeGroups(fccId: string): Promise<AttributeTypeGroup[]>

  /**
   * Create a new attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type group will be created
   * @param atgCreateRequest The data of the new attribute type group in JSON format
   * @return The newly created attribute type group
   */
  createAttributeTypeGroup(
    fccId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequest
  ): Promise<AttributeTypeGroup>

  /**
   * Get the specified attribute type group defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type group is defined
   * @param atgId Id of the attribute type group to get
   * @return The attribute type group
   */
  getAttributeTypeGroup(fccId: string, atgId: number): Promise<AttributeTypeGroup>

  /**
   * Update the specified attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type group will be created
   * @param atgId Id of the attribute type group to update
   * @param atgUpdateRequest The data of the new attribute type group in JSON format
   * @return The successfully updated attribute type group
   */
  updateAttributeTypeGroup(
    fccId: string,
    atgId: number,
    atgUpdateRequest: AttributeTypeGroupUpdateRequest
  ): Promise<AttributeTypeGroup>

  /**
   * Remove the specified attribute type group with all its attribute types
   * @param fccId Id of the feature catalog customization where attribute type group will be removed from
   * @param atgId Id of the attribute type group to remove
   * @return Attribute type group successfully deleted.
   */
  deleteAttributeTypeGroup(fccId: string, atgId: number): Promise<void>

  /**
   * Get all feature type (group) associations for the specified attribute type group in
             the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization containing the attribute types group
   * @param atgId Id of attribute type group to get feature type associations for
   * @return List of feature type groups and feature types using the attribute type group
   */
  getAttributeTypesGroupAssociations(fccId: string, atgId: number): Promise<AttributeTypeGroupUsage>

  /**
   * Update the feature type (group) associations for the specified attribute type group in
             the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization containing the attribute type group
   * @param atgId Id of attribute type group to update feature type associations for
   * @param atgUsageUpdateRequest List of feature type groups ids and feature type ids associated with this attribute type group
   * @return List of feature type groups and feature types using the attribute type group
   */
  updateAttributeTypesGroupAssociations(
    fccId: string,
    atgId: number,
    atgUsageUpdateRequest: AttributeTypeGroupUsageUpdateRequest
  ): Promise<AttributeTypeGroupUsage>

  /**
   * Get all attribute types defined for the specified feature catalog customization in the specified attribute type group
   * @param fccId Id of the feature catalog customization to get attribute types for
   * @param atgId Persistent Id of attribute type group to get attribute types for
   * @return The list of attribute types
   */
  getAttributeTypesByGroup(fccId: string, atgId: number): Promise<CustomAttributeType[]>

  /**
   * Create a new attribute type in the specified attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type will be created
   * @param atgId Id of attribute type group to place the attribute type into
   * @param atCreateRequest The data of the new attribute type in JSON format
   * @return The newly created attribute type
   */
  createAttributeType(
    fccId: string,
    atgId: number,
    atCreateRequest: AttributeTypeCreateRequest
  ): Promise<CustomAttributeType>

  /**
   * Get all attribute types defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get attribute types for
   * @return The list of attribute types
   */
  getAttributeTypes(fccId: string): Promise<AttributeType[]>

  /**
   * Get the specified attribute type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get
   * @return The attribute type
   */
  getAttributeType(fccId: string, atId: number): Promise<CustomAttributeType>

  /**
   * Remove the specified attribute type
   * @param fccId Id of the feature catalog customization where attribute type will be removed from
   * @param atId Persistent Id of the attribute type to remove
   * @return Attribute type successfully deleted.
   */
  deleteAttributeType(fccId: string, atId: number): Promise<void>

  /**
   * Update the specified attribute type
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to update
   * @param atUpdateRequest New values for the attribute type to update
   */
  updateAttributeType(
    fccId: string,
    atId: number,
    atUpdateRequest: AttributeTypeUpdateRequest
  ): Promise<CustomAttributeType>

  /**
   * Get all legal values of the specified attribute type defined for the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get legal values for
   * @return The list of legal attribute values
   */
  getLegalValuesOfAttributeType(fccId: string, atId: number): Promise<LegalAttributeValue[]>

  /**
   * Update all legal values of the specified attribute type in the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to update legal values for
   * @param allValues List of all legal values for the specified attribute type. Both JSON and CSV are supported.
  Value and Caption are required fields, all others are optional. Legal Values that are already in a published version cannot
  be removed or change its value. For new values, ID must be set to zero or blank.
  For CSV, header row is required and separator character must be comma.
   * @return The list of legal attribute values
   */
  updateLegalValuesOfAttributeType(
    fccId: string,
    atId: number,
    allValues: LegalAttributeValue[]
  ): Promise<LegalAttributeValue[]>

  /**
   * Create a new legal value of the specified attribute type in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization containing the attribute type is
   * @param atId Id of the attribute type to add the legal value into
   * @param legalValueCreateRequest The data of the new legal value in JSON format
   * @return The newly created legal value
   */
  createLegalValueOfAttributeType(
    fccId: string,
    atId: number,
    legalValueCreateRequest: LegalValueCreateRequest
  ): Promise<LegalAttributeValue>

  /**
   * Get the specified legal value of the specified attribute type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get legal value for
   * @param lvId Id of the legal value
   * @return The legal attribute value
   */
  getLegalValueOfAttributeType(fccId: string, atId: number, lvId: number): Promise<LegalAttributeValue>

  /**
   * Remove the specified legal value from the specified attribute type
   * @param fccId Id of the feature catalog customization containing the attribute type
   * @param atId Id of the attribute type to remove the legal value from
   * @param lvId Id of the legal value to remove
   * @return Legal value successfully deleted.
   */
  deleteLegalValueOfAttributeType(fccId: string, atId: number, lvId: number): Promise<void>

  /**
   * Update the specified legal value
   * @param fccId Id of the feature catalog customization where the attribute type of the legal value is defined
   * @param atId Id of the attribute type of the legal value
   * @param lvId Id of the legal value to update
   * @param lvUpdateRequest New values for the legal value to update
   */
  updateLegalValueOfAttributeType(
    fccId: string,
    atId: number,
    lvId: number,
    lvUpdateRequest: LegalValueUpdateRequest
  ): Promise<LegalAttributeValue>

  /**
   * Get all feature types defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get feature types for
   * @return The list of feature types
   */
  getFeatureTypes(fccId: string): Promise<CustomFeatureType[]>

  /**
   * Create a new feature type in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where feature type will be created
   * @param ftCreateRequest The data of the new feature type
   * @return The newly created feature type
   */
  createFeatureType(fccId: string, ftCreateRequest: FeatureTypeCreateRequest): Promise<CustomFeatureType>

  /**
   * Starts a process to update all custom feature types in the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization where the feature types should be defined
   * @param allFeatureTypes List of all custom feature types in csv format.
  FeatureTypeName is only required field, all others are optional. Feature Types that are already in a published version cannot
  be removed or loose a geometry type. For new feature types, ID must be set to zero or blank.
  For CSV, header row is required and separator character must be comma.
   * @return Information about the import process started
   */
  updateFeatureTypesCsv(
    fccId: string,
    allFeatureTypes: CustomFeatureTypeUpsertCsv[]
  ): Promise<FCCustomizationImportProgress>

  /**
   * Starts a process to update all custom feature types in the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization where the feature types should be defined
   * @param excelFile (optional)
   * @return Information about the import process started
   */
  updateFeatureTypesExcel(
    fccId: string,
    excelFile?: FileParameter | null | undefined
  ): Promise<FCCustomizationImportProgress>

  /**
   * Get the specified feature type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the feature type is defined
   * @param ftId Id of the feature type to get
   * @return The feature type
   */
  getFeatureType(fccId: string, ftId: number): Promise<CustomFeatureType>

  /**
   * Update the specified feature type
   * @param fccId Id of the feature catalog customization where the feature type is defined
   * @param ftId Id of the feature type to update
   * @param ftUpdateRequest New values for the feature type to update
   */
  updateFeatureType(fccId: string, ftId: number, ftUpdateRequest: FeatureTypeUpdateRequest): Promise<CustomFeatureType>

  /**
   * Remove the specified feature type
   * @param fccId Id of the feature catalog customization where feature type will be removed from
   * @param ftId Persistent Id of the feature type to remove
   * @return Feature type successfully deleted.
   */
  deleteFeatureType(fccId: string, ftId: number): Promise<void>
}

export class FCCustomizationsClient implements IFCCustomizationsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Create a new feature catalog customization
   * @param fccCreateRequest The data of the new feature catalog customization in JSON format
   * @return The newly created feature catalog customization
   */
  createFCCustomization(fccCreateRequest: FCCustomizationCreateRequest): Promise<FCCustomizationCombined> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(fccCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFCCustomization(_response)
    })
  }

  protected processCreateFCCustomization(response: Response): Promise<FCCustomizationCombined> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined>(null as any)
  }

  /**
   * Get all feature catalog customizations that the authenticated user has access to
   * @return The list of feature catalog customizations
   */
  getFCCustomizations(): Promise<FCCustomization[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFCCustomizations(_response)
    })
  }

  protected processGetFCCustomizations(response: Response): Promise<FCCustomization[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomization[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomization[]>(null as any)
  }

  /**
   * Get a specific feature catalog customization id
   * @param fccId Id of the feature catalog customization to get
   * @return The feature catalog customization info
   */
  getFCCustomization(fccId: string): Promise<FCCustomizationCombined> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFCCustomization(_response)
    })
  }

  protected processGetFCCustomization(response: Response): Promise<FCCustomizationCombined> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined>(null as any)
  }

  /**
   * Updates the feature catalog customization by id
   * @param fccId ID of the feature catalog customization to update
   * @param fccUpdateRequest FCCustomizationUpdateRequest containing the new values.
   * @return The successfully updated feature catalog customization
   */
  updateFCCustomization(
    fccId: string,
    fccUpdateRequest: FCCustomizationUpdateRequest
  ): Promise<FCCustomizationCombined> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(fccUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFCCustomization(_response)
    })
  }

  protected processUpdateFCCustomization(response: Response): Promise<FCCustomizationCombined> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined>(null as any)
  }

  /**
   * Remove the current version of the feature catalog customization with the specified id
   * @param fccId Id of the feature catalog customization to remove
   * @return Feature Catalog Customization successfully deleted.
   */
  deleteFCCustomization(fccId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFCCustomization(_response)
    })
  }

  protected processDeleteFCCustomization(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified (is published).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Exports the specified feature catalog customization as an Excel file
   * @param fccId Id of the feature catalog customization to export
   * @param includeIds (optional) Set to true in order to include ID column in the sheets. Default is false
   * @param valueSeparator (optional) Character to be used to separate multiple values in a cell. Default is pipe |
   * @return Excel file containing the types of the the feature catalog customization
   */
  exportFCCustomizationToExcel(
    fccId: string,
    includeIds?: boolean | undefined,
    valueSeparator?: string | null | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/exports/excel?"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (includeIds === null) throw new Error("The parameter 'includeIds' cannot be null.")
    else if (includeIds !== undefined) url_ += "includeIds=" + encodeURIComponent("" + includeIds) + "&"
    if (valueSeparator !== undefined && valueSeparator !== null)
      url_ += "valueSeparator=" + encodeURIComponent("" + valueSeparator) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/octet-stream"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processExportFCCustomizationToExcel(_response)
    })
  }

  protected processExportFCCustomizationToExcel(response: Response): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined
      if (fileName) {
        fileName = decodeURIComponent(fileName)
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      }
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers }
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FileResponse>(null as any)
  }

  /**
   * Starts a process to import content to the specified feature catalog customization from an excel file.
   * @param fccId ID of the feature catalog customization to import into
   * @param excelFile (optional)
   * @return Information about the import process started
   */
  importFCCustomizationFromExcel(
    fccId: string,
    excelFile?: FileParameter | null | undefined
  ): Promise<FCCustomizationImportProgress> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/imports/excel"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = new FormData()
    if (excelFile !== null && excelFile !== undefined)
      content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile")

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processImportFCCustomizationFromExcel(_response)
    })
  }

  protected processImportFCCustomizationFromExcel(response: Response): Promise<FCCustomizationImportProgress> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationImportProgress)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationImportProgress>(null as any)
  }

  /**
   * Get progress and status of the specified import process to the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization
   * @param ticketId ID (ticket) of the import process
   * @return The content of the excel file was successfully imported into the feature catalog customization
   */
  getFccImportProgress(fccId: string, ticketId: string): Promise<FCCustomizationImportProgress> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/imports/{ticketId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (ticketId === undefined || ticketId === null) throw new Error("The parameter 'ticketId' must be defined.")
    url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFccImportProgress(_response)
    })
  }

  protected processGetFccImportProgress(response: Response): Promise<FCCustomizationImportProgress> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationImportProgress)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationImportProgress>(null as any)
  }

  /**
   * Get all versions of the specified feature catalog customization
   * @return The list of feature catalog customization versions
   */
  getFCCustomizationVersions(fccId: string): Promise<FCCustomizationCombined[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFCCustomizationVersions(_response)
    })
  }

  protected processGetFCCustomizationVersions(response: Response): Promise<FCCustomizationCombined[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined[]>(null as any)
  }

  /**
   * Create a new version of the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to make a new version of
   * @param fccCreateRequest The data of the new feature catalog customization version in JSON format
   * @return The newly created version of the feature catalog customization
   */
  createFCCustomizationVersion(
    fccId: string,
    fccCreateRequest: FCCustomizationCreateRequest
  ): Promise<FCCustomizationCombined> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(fccCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFCCustomizationVersion(_response)
    })
  }

  protected processCreateFCCustomizationVersion(response: Response): Promise<FCCustomizationCombined> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization is still open.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined>(null as any)
  }

  /**
   * Get a specific feature catalog customization version by id and version
   * @param fccId Id of the feature catalog customization to get
   * @param fccVersionNumber Version number for the feature catalog customization version to get.
   * @return The feature catalog customization version
   */
  getFCCustomizationVersion(fccId: string, fccVersionNumber: number): Promise<FCCustomizationCombined> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFCCustomizationVersion(_response)
    })
  }

  protected processGetFCCustomizationVersion(response: Response): Promise<FCCustomizationCombined> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationCombined)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID and version number was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationCombined>(null as any)
  }

  /**
   * Gets all user roles for the specified feature catalog customization i.e. who has access to the customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @return List of user roles
   */
  getUserRoles(fccId: string): Promise<UserRole[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/users"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRoles(_response)
    })
  }

  protected processGetUserRoles(response: Response): Promise<UserRole[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole[]>(null as any)
  }

  /**
   * Adds a user role to the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @param userRoleCreateRequest Role and user information for the new user role
   * @return User role successfully removed.
   */
  createUserRole(fccId: string, userRoleCreateRequest: UserRoleCreateRequest): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/users"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(userRoleCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateUserRole(_response)
    })
  }

  protected processCreateUserRole(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID or user role for the user with specified ID.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not create duplicate user roles", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Gets the specified user role for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to get
   * @return User role
   */
  getUserRole(fccId: string, userIdOrEmail: string): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/users/{userIdOrEmail}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRole(_response)
    })
  }

  protected processGetUserRole(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Update the specified user role for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to update user role for
   * @param userIdOrEmail Id or e-mail of user in the user role to update
   * @param updateRequest New Role
   * @return User role successfully updated.
   */
  updateUserRole(fccId: string, userIdOrEmail: string, updateRequest: UserRoleUpdateRequest): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/users/{userIdOrEmail}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(updateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateUserRole(_response)
    })
  }

  protected processUpdateUserRole(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not update user role for owner", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Remove the specified user role from the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to remove user roles from
   * @param userIdOrEmail Id or e-mail of user in the user role to remove
   * @return User role successfully removed.
   */
  deleteUserRole(fccId: string, userIdOrEmail: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/users/{userIdOrEmail}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteUserRole(_response)
    })
  }

  protected processDeleteUserRole(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not remove user role for owner", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Get a reference to all classifications associated with the current version of the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get classifications for
   * @return The list of classifications
   */
  getClassificationsFromCurrentVersion(fccId: string): Promise<ClassificationHeader[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/classifications"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClassificationsFromCurrentVersion(_response)
    })
  }

  protected processGetClassificationsFromCurrentVersion(response: Response): Promise<ClassificationHeader[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationHeader[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationHeader[]>(null as any)
  }

  /**
   * Get a reference to all classifications associated with the specified feature catalog customization and version
   * @param fccId Id of the feature catalog customization to get classifications for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classifications for.
   * @return The list of classifications
   */
  getClassifications(fccId: string, fccVersionNumber: number): Promise<ClassificationHeader[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}/classifications"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClassifications(_response)
    })
  }

  protected processGetClassifications(response: Response): Promise<ClassificationHeader[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationHeader[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationHeader[]>(null as any)
  }

  /**
   * Add usage of the specified classification to the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param classificationReference Reference to an existing classification and category to attribute type mapping
   * @return The classification reference added
   */
  createClassificationUsage(
    fccId: string,
    fccVersionNumber: number,
    classificationReference: ClassificationReference
  ): Promise<ClassificationReference> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}/classifications"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(classificationReference)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateClassificationUsage(_response)
    })
  }

  protected processCreateClassificationUsage(response: Response): Promise<ClassificationReference> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationReference)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource or access the specified classification.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The classification reference with the specified ID is already in use by the specified feature catalog customization version",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationReference>(null as any)
  }

  /**
   * Get the specified complete classification structure with category to attribute type mapping in the current version
             of the feature catalog customization
   * @param fccId Id of the feature catalog customization to get classification for
   * @param cId Id of the classification structure to get
   * @return The list of classifications
   */
  getFullClassificationFromCurrentVersion(fccId: string, cId: string): Promise<ClassificationHeader[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/classifications/{cId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFullClassificationFromCurrentVersion(_response)
    })
  }

  protected processGetFullClassificationFromCurrentVersion(response: Response): Promise<ClassificationHeader[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationHeader[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number or the classification with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationHeader[]>(null as any)
  }

  /**
   * Get the specified complete classification structure with category to attribute type mapping
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param cId Id of the classification structure to get
   * @return The full classification structure
   */
  getFullClassification(
    fccId: string,
    fccVersionNumber: number,
    cId: string
  ): Promise<ClassificationFullOfCategoryToAttributeConnectionExtended[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}/classifications/{cId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFullClassification(_response)
    })
  }

  protected processGetFullClassification(
    response: Response
  ): Promise<ClassificationFullOfCategoryToAttributeConnectionExtended[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ClassificationFullOfCategoryToAttributeConnectionExtended[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number or the classification with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationFullOfCategoryToAttributeConnectionExtended[]>(null as any)
  }

  /**
   * Update usage of the specified classification in the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to get classification for
   * @param fccVersionNumber Version number for the feature catalog customization version to get classification for.
   * @param cId Id of the classification structure to update reference to
   * @param classificationReference Reference to an existing classification and category to attribute type mapping
   * @return The updated classification reference
   */
  updateClassificationUsage(
    fccId: string,
    fccVersionNumber: number,
    cId: string,
    classificationReference: ClassificationReference
  ): Promise<ClassificationReference> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}/classifications/{cId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(classificationReference)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateClassificationUsage(_response)
    })
  }

  protected processUpdateClassificationUsage(response: Response): Promise<ClassificationReference> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClassificationReference)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number was not found, or the reference to the classification (or the classification itself) with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<ClassificationReference>(null as any)
  }

  /**
   * Remove the usage of the specified classification from the specified feature catalog customization version
   * @param fccId Id of the feature catalog customization to remove classification usage from
   * @param fccVersionNumber Version number for the feature catalog customization version to remove classification usage from.
   * @param cId Id of the classification to remove usage of
   * @return Classification reference successfully removed
   */
  deleteClassificationUsage(fccId: string, fccVersionNumber: number, cId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/versions/{fccVersionNumber}/classifications/{cId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (fccVersionNumber === undefined || fccVersionNumber === null)
      throw new Error("The parameter 'fccVersionNumber' must be defined.")
    url_ = url_.replace("{fccVersionNumber}", encodeURIComponent("" + fccVersionNumber))
    if (cId === undefined || cId === null) throw new Error("The parameter 'cId' must be defined.")
    url_ = url_.replace("{cId}", encodeURIComponent("" + cId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteClassificationUsage(_response)
    })
  }

  protected processDeleteClassificationUsage(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization version with the specified ID and version number was not found, or the reference to the classification with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Get all attribute type groups defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get attribute type groups for
   * @return The list of attribute type groups
   */
  getAttributeTypeGroups(fccId: string): Promise<AttributeTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroups(_response)
    })
  }

  protected processGetAttributeTypeGroups(response: Response): Promise<AttributeTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroup[]>(null as any)
  }

  /**
   * Create a new attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type group will be created
   * @param atgCreateRequest The data of the new attribute type group in JSON format
   * @return The newly created attribute type group
   */
  createAttributeTypeGroup(
    fccId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequest
  ): Promise<AttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atgCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateAttributeTypeGroup(_response)
    })
  }

  protected processCreateAttributeTypeGroup(response: Response): Promise<AttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroup)
        return result201
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroup>(null as any)
  }

  /**
   * Get the specified attribute type group defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type group is defined
   * @param atgId Id of the attribute type group to get
   * @return The attribute type group
   */
  getAttributeTypeGroup(fccId: string, atgId: number): Promise<AttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroup(_response)
    })
  }

  protected processGetAttributeTypeGroup(response: Response): Promise<AttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroup>(null as any)
  }

  /**
   * Update the specified attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type group will be created
   * @param atgId Id of the attribute type group to update
   * @param atgUpdateRequest The data of the new attribute type group in JSON format
   * @return The successfully updated attribute type group
   */
  updateAttributeTypeGroup(
    fccId: string,
    atgId: number,
    atgUpdateRequest: AttributeTypeGroupUpdateRequest
  ): Promise<AttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atgUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateAttributeTypeGroup(_response)
    })
  }

  protected processUpdateAttributeTypeGroup(response: Response): Promise<AttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroup>(null as any)
  }

  /**
   * Remove the specified attribute type group with all its attribute types
   * @param fccId Id of the feature catalog customization where attribute type group will be removed from
   * @param atgId Id of the attribute type group to remove
   * @return Attribute type group successfully deleted.
   */
  deleteAttributeTypeGroup(fccId: string, atgId: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteAttributeTypeGroup(_response)
    })
  }

  protected processDeleteAttributeTypeGroup(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the attribute type group can not be deleted.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Get all feature type (group) associations for the specified attribute type group in
             the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization containing the attribute types group
   * @param atgId Id of attribute type group to get feature type associations for
   * @return List of feature type groups and feature types using the attribute type group
   */
  getAttributeTypesGroupAssociations(fccId: string, atgId: number): Promise<AttributeTypeGroupUsage> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}/associations"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesGroupAssociations(_response)
    })
  }

  protected processGetAttributeTypesGroupAssociations(response: Response): Promise<AttributeTypeGroupUsage> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroupUsage)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroupUsage>(null as any)
  }

  /**
   * Update the feature type (group) associations for the specified attribute type group in
             the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization containing the attribute type group
   * @param atgId Id of attribute type group to update feature type associations for
   * @param atgUsageUpdateRequest List of feature type groups ids and feature type ids associated with this attribute type group
   * @return List of feature type groups and feature types using the attribute type group
   */
  updateAttributeTypesGroupAssociations(
    fccId: string,
    atgId: number,
    atgUsageUpdateRequest: AttributeTypeGroupUsageUpdateRequest
  ): Promise<AttributeTypeGroupUsage> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}/associations"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atgUsageUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateAttributeTypesGroupAssociations(_response)
    })
  }

  protected processUpdateAttributeTypesGroupAssociations(response: Response): Promise<AttributeTypeGroupUsage> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeTypeGroupUsage)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "A feature type (group) - attribute type group association introduced in an earlier version can not be removed.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeTypeGroupUsage>(null as any)
  }

  /**
   * Get all attribute types defined for the specified feature catalog customization in the specified attribute type group
   * @param fccId Id of the feature catalog customization to get attribute types for
   * @param atgId Persistent Id of attribute type group to get attribute types for
   * @return The list of attribute types
   */
  getAttributeTypesByGroup(fccId: string, atgId: number): Promise<CustomAttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}/attributeTypes"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesByGroup(_response)
    })
  }

  protected processGetAttributeTypesByGroup(response: Response): Promise<CustomAttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomAttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomAttributeType[]>(null as any)
  }

  /**
   * Create a new attribute type in the specified attribute type group in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where attribute type will be created
   * @param atgId Id of attribute type group to place the attribute type into
   * @param atCreateRequest The data of the new attribute type in JSON format
   * @return The newly created attribute type
   */
  createAttributeType(
    fccId: string,
    atgId: number,
    atCreateRequest: AttributeTypeCreateRequest
  ): Promise<CustomAttributeType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypeGroups/{atgId}/attributeTypes"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateAttributeType(_response)
    })
  }

  protected processCreateAttributeType(response: Response): Promise<CustomAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomAttributeType)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type group with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomAttributeType>(null as any)
  }

  /**
   * Get all attribute types defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get attribute types for
   * @return The list of attribute types
   */
  getAttributeTypes(fccId: string): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypes(_response)
    })
  }

  protected processGetAttributeTypes(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get the specified attribute type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get
   * @return The attribute type
   */
  getAttributeType(fccId: string, atId: number): Promise<CustomAttributeType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeType(_response)
    })
  }

  protected processGetAttributeType(response: Response): Promise<CustomAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomAttributeType>(null as any)
  }

  /**
   * Remove the specified attribute type
   * @param fccId Id of the feature catalog customization where attribute type will be removed from
   * @param atId Persistent Id of the attribute type to remove
   * @return Attribute type successfully deleted.
   */
  deleteAttributeType(fccId: string, atId: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteAttributeType(_response)
    })
  }

  protected processDeleteAttributeType(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the attribute type can not be deleted.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Update the specified attribute type
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to update
   * @param atUpdateRequest New values for the attribute type to update
   */
  updateAttributeType(
    fccId: string,
    atId: number,
    atUpdateRequest: AttributeTypeUpdateRequest
  ): Promise<CustomAttributeType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateAttributeType(_response)
    })
  }

  protected processUpdateAttributeType(response: Response): Promise<CustomAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the attribute type can not be updated.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomAttributeType>(null as any)
  }

  /**
   * Get all legal values of the specified attribute type defined for the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get legal values for
   * @return The list of legal attribute values
   */
  getLegalValuesOfAttributeType(fccId: string, atId: number): Promise<LegalAttributeValue[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLegalValuesOfAttributeType(_response)
    })
  }

  protected processGetLegalValuesOfAttributeType(response: Response): Promise<LegalAttributeValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as LegalAttributeValue[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<LegalAttributeValue[]>(null as any)
  }

  /**
   * Update all legal values of the specified attribute type in the specified feature catalog customization.
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to update legal values for
   * @param allValues List of all legal values for the specified attribute type. Both JSON and CSV are supported.
  Value and Caption are required fields, all others are optional. Legal Values that are already in a published version cannot
  be removed or change its value. For new values, ID must be set to zero or blank.
  For CSV, header row is required and separator character must be comma.
   * @return The list of legal attribute values
   */
  updateLegalValuesOfAttributeType(
    fccId: string,
    atId: number,
    allValues: LegalAttributeValue[]
  ): Promise<LegalAttributeValue[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(allValues)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateLegalValuesOfAttributeType(_response)
    })
  }

  protected processUpdateLegalValuesOfAttributeType(response: Response): Promise<LegalAttributeValue[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as LegalAttributeValue[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified, published legal values cannot be removed or the specified attribute type doesn't support legal values.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<LegalAttributeValue[]>(null as any)
  }

  /**
   * Create a new legal value of the specified attribute type in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization containing the attribute type is
   * @param atId Id of the attribute type to add the legal value into
   * @param legalValueCreateRequest The data of the new legal value in JSON format
   * @return The newly created legal value
   */
  createLegalValueOfAttributeType(
    fccId: string,
    atId: number,
    legalValueCreateRequest: LegalValueCreateRequest
  ): Promise<LegalAttributeValue> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(legalValueCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateLegalValueOfAttributeType(_response)
    })
  }

  protected processCreateLegalValueOfAttributeType(response: Response): Promise<LegalAttributeValue> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as LegalAttributeValue)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or attribute type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the specified attribute type doesn't support legal values.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<LegalAttributeValue>(null as any)
  }

  /**
   * Get the specified legal value of the specified attribute type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the attribute type is defined
   * @param atId Id of the attribute type to get legal value for
   * @param lvId Id of the legal value
   * @return The legal attribute value
   */
  getLegalValueOfAttributeType(fccId: string, atId: number, lvId: number): Promise<LegalAttributeValue> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues/{lvId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (lvId === undefined || lvId === null) throw new Error("The parameter 'lvId' must be defined.")
    url_ = url_.replace("{lvId}", encodeURIComponent("" + lvId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLegalValueOfAttributeType(_response)
    })
  }

  protected processGetLegalValueOfAttributeType(response: Response): Promise<LegalAttributeValue> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as LegalAttributeValue)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization, attribute type or legal value with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<LegalAttributeValue>(null as any)
  }

  /**
   * Remove the specified legal value from the specified attribute type
   * @param fccId Id of the feature catalog customization containing the attribute type
   * @param atId Id of the attribute type to remove the legal value from
   * @param lvId Id of the legal value to remove
   * @return Legal value successfully deleted.
   */
  deleteLegalValueOfAttributeType(fccId: string, atId: number, lvId: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues/{lvId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (lvId === undefined || lvId === null) throw new Error("The parameter 'lvId' must be defined.")
    url_ = url_.replace("{lvId}", encodeURIComponent("" + lvId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteLegalValueOfAttributeType(_response)
    })
  }

  protected processDeleteLegalValueOfAttributeType(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization, attribute type or legal value with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or legal value can not be deleted.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Update the specified legal value
   * @param fccId Id of the feature catalog customization where the attribute type of the legal value is defined
   * @param atId Id of the attribute type of the legal value
   * @param lvId Id of the legal value to update
   * @param lvUpdateRequest New values for the legal value to update
   */
  updateLegalValueOfAttributeType(
    fccId: string,
    atId: number,
    lvId: number,
    lvUpdateRequest: LegalValueUpdateRequest
  ): Promise<LegalAttributeValue> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues/{lvId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (lvId === undefined || lvId === null) throw new Error("The parameter 'lvId' must be defined.")
    url_ = url_.replace("{lvId}", encodeURIComponent("" + lvId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(lvUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateLegalValueOfAttributeType(_response)
    })
  }

  protected processUpdateLegalValueOfAttributeType(response: Response): Promise<LegalAttributeValue> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as LegalAttributeValue)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization, attribute type or legal value with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the legal value can not be updated.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<LegalAttributeValue>(null as any)
  }

  /**
   * Get all feature types defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization to get feature types for
   * @return The list of feature types
   */
  getFeatureTypes(fccId: string): Promise<CustomFeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypes(_response)
    })
  }

  protected processGetFeatureTypes(response: Response): Promise<CustomFeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureType[]>(null as any)
  }

  /**
   * Create a new feature type in the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where feature type will be created
   * @param ftCreateRequest The data of the new feature type
   * @return The newly created feature type
   */
  createFeatureType(fccId: string, ftCreateRequest: FeatureTypeCreateRequest): Promise<CustomFeatureType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(ftCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateFeatureType(_response)
    })
  }

  protected processCreateFeatureType(response: Response): Promise<CustomFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureType)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or feature type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureType>(null as any)
  }

  /**
   * Starts a process to update all custom feature types in the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization where the feature types should be defined
   * @param allFeatureTypes List of all custom feature types in csv format.
  FeatureTypeName is only required field, all others are optional. Feature Types that are already in a published version cannot
  be removed or loose a geometry type. For new feature types, ID must be set to zero or blank.
  For CSV, header row is required and separator character must be comma.
   * @return Information about the import process started
   */
  updateFeatureTypesCsv(
    fccId: string,
    allFeatureTypes: CustomFeatureTypeUpsertCsv[]
  ): Promise<FCCustomizationImportProgress> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes.csv"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(allFeatureTypes)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFeatureTypesCsv(_response)
    })
  }

  protected processUpdateFeatureTypesCsv(response: Response): Promise<FCCustomizationImportProgress> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationImportProgress)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified, published feature types cannot be removed or loose geometry type.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationImportProgress>(null as any)
  }

  /**
   * Starts a process to update all custom feature types in the specified feature catalog customization.
   * @param fccId ID of the feature catalog customization where the feature types should be defined
   * @param excelFile (optional)
   * @return Information about the import process started
   */
  updateFeatureTypesExcel(
    fccId: string,
    excelFile?: FileParameter | null | undefined
  ): Promise<FCCustomizationImportProgress> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes.xlsx"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = new FormData()
    if (excelFile !== null && excelFile !== undefined)
      content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile")

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFeatureTypesExcel(_response)
    })
  }

  protected processUpdateFeatureTypesExcel(response: Response): Promise<FCCustomizationImportProgress> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as FCCustomizationImportProgress)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified, published feature types cannot be removed or loose geometry type.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCCustomizationImportProgress>(null as any)
  }

  /**
   * Get the specified feature type defined for the specified feature catalog customization
   * @param fccId Id of the feature catalog customization where the feature type is defined
   * @param ftId Id of the feature type to get
   * @return The feature type
   */
  getFeatureType(fccId: string, ftId: number): Promise<CustomFeatureType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes/{ftId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureType(_response)
    })
  }

  protected processGetFeatureType(response: Response): Promise<CustomFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or feature type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureType>(null as any)
  }

  /**
   * Update the specified feature type
   * @param fccId Id of the feature catalog customization where the feature type is defined
   * @param ftId Id of the feature type to update
   * @param ftUpdateRequest New values for the feature type to update
   */
  updateFeatureType(
    fccId: string,
    ftId: number,
    ftUpdateRequest: FeatureTypeUpdateRequest
  ): Promise<CustomFeatureType> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes/{ftId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(ftUpdateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFeatureType(_response)
    })
  }

  protected processUpdateFeatureType(response: Response): Promise<CustomFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CustomFeatureType)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or feature type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the feature type can not be updated.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<CustomFeatureType>(null as any)
  }

  /**
   * Remove the specified feature type
   * @param fccId Id of the feature catalog customization where feature type will be removed from
   * @param ftId Persistent Id of the feature type to remove
   * @return Feature type successfully deleted.
   */
  deleteFeatureType(fccId: string, ftId: number): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/fcCustomizations/{fccId}/featureTypes/{ftId}"
    if (fccId === undefined || fccId === null) throw new Error("The parameter 'fccId' must be defined.")
    url_ = url_.replace("{fccId}", encodeURIComponent("" + fccId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteFeatureType(_response)
    })
  }

  protected processDeleteFeatureType(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog customization or feature type with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The current version of the feature catalog customization can not be modified or the feature type can not be deleted.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }
}

export interface IFeatureCatalogsClient {
  /**
   * Get all standard feature catalogs that meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of standard feature catalogs
   */
  getFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<FeatureCatalogCommon[]>

  /**
   * Publish a new standard feature catalog by uploading a .qfc file.
             NB: Quadri Configuration Admins only
   * @param qfcFile (optional) 
   * @return Information about the started publishing process
   */
  publishFeatureCatalog(qfcFile?: FileParameter | null | undefined): Promise<PublishFCAccepted>

  /**
   * Get the standard feature catalog with the specified id
   * @param fcId Id of the feature catalog to get
   * @return The feature catalog
   */
  getFeatureCatalog(fcId: string): Promise<FeatureCatalogCommon>

  /**
   * Gets all tags for the feature catalog
   * @param fcId ID of the feature catalog to get tags for
   * @return List of tags
   */
  getTagsForFeatureCatalog(fcId: string): Promise<Tag[]>

  /**
   * Adds a tag to the specified feature catalog
   * @param fcId ID of feature catalog to add tag to
   * @param tagCreateRequest The Tag to add
   * @return Tag successfully added.
   */
  addTagToFeatureCatalog(fcId: string, tagCreateRequest: TagCreateRequest): Promise<Tag>

  /**
   * Remove the specified tag from the specified feature catalog
   * @param fcId Id of feature catalog to remove tag from
   * @param tag Tag to remove from feature catalog. Could be name or id of the tag
   * @return Tag successfully removed.
   */
  deleteTagFromFeatureCatalog(fcId: string, tag: string): Promise<void>

  /**
   * Publish resources for a feature catalog in the specified language by uploading a .resx file
             NB: Quadri Configuration Admins only
   * @param resxFile (optional) 
   * @return Resource file successfully updated
   */
  publishFeatureCatalogResources(
    languageCode: string,
    resxFile?: FileParameter | null | undefined
  ): Promise<PublishFCResourcesOk>

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation>

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]>

  /**
   * List all feature type groups of the specified standard feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]>

  /**
   * Get the specified feature type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended>

  /**
   * List all feature types in the specified feature type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * List all feature types in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * Get the specified feature type in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType>

  /**
   * List all attribute type groups of the specified standard feature catalog
   * @param fcId ID of the feature catalog to get attribute type groups for.
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]>

  /**
   * Get the specified attribute type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * List all attribute types in the specified attribute type group in the specified standard feature catalog
   * @param fcId ID of the feature catalog containing the attribute types
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(fcId: string, atgId: number, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * List all attribute types in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog containing the attribute types
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get the specified attribute type in the specified standard feature catalog
   * @param fcId ID of the feature catalog containing the attribute type
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType>
}

export class FeatureCatalogsClient implements IFeatureCatalogsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all standard feature catalogs that meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of standard feature catalogs
   */
  getFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<FeatureCatalogCommon[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs?"
    if (standard !== undefined && standard !== null) url_ += "standard=" + encodeURIComponent("" + standard) + "&"
    if (minimumVersion !== undefined && minimumVersion !== null)
      url_ += "minimumVersion=" + encodeURIComponent("" + minimumVersion) + "&"
    if (maximumStreamVersion !== undefined && maximumStreamVersion !== null)
      url_ += "maximumStreamVersion=" + encodeURIComponent("" + maximumStreamVersion) + "&"
    if (tags !== undefined && tags !== null) url_ += "tags=" + encodeURIComponent("" + tags) + "&"
    if (excludeFcUri === null) throw new Error("The parameter 'excludeFcUri' cannot be null.")
    else if (excludeFcUri !== undefined) url_ += "excludeFcUri=" + encodeURIComponent("" + excludeFcUri) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalogs(_response)
    })
  }

  protected processGetFeatureCatalogs(response: Response): Promise<FeatureCatalogCommon[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureCatalogCommon[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureCatalogCommon[]>(null as any)
  }

  /**
   * Publish a new standard feature catalog by uploading a .qfc file.
             NB: Quadri Configuration Admins only
   * @param qfcFile (optional) 
   * @return Information about the started publishing process
   */
  publishFeatureCatalog(qfcFile?: FileParameter | null | undefined): Promise<PublishFCAccepted> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = new FormData()
    if (qfcFile !== null && qfcFile !== undefined)
      content_.append("qfcFile", qfcFile.data, qfcFile.fileName ? qfcFile.fileName : "qfcFile")

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPublishFeatureCatalog(_response)
    })
  }

  protected processPublishFeatureCatalog(response: Response): Promise<PublishFCAccepted> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PublishFCAccepted)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "User / Client is not authorized to perform this operation.",
          status,
          _responseText,
          _headers
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          "There is already a feature catalog with the same ID published or under construction",
          status,
          _responseText,
          _headers
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PublishFCAccepted>(null as any)
  }

  /**
   * Get the standard feature catalog with the specified id
   * @param fcId Id of the feature catalog to get
   * @return The feature catalog
   */
  getFeatureCatalog(fcId: string): Promise<FeatureCatalogCommon> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalog(_response)
    })
  }

  protected processGetFeatureCatalog(response: Response): Promise<FeatureCatalogCommon> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureCatalogCommon)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureCatalogCommon>(null as any)
  }

  /**
   * Gets all tags for the feature catalog
   * @param fcId ID of the feature catalog to get tags for
   * @return List of tags
   */
  getTagsForFeatureCatalog(fcId: string): Promise<Tag[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/tags"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTagsForFeatureCatalog(_response)
    })
  }

  protected processGetTagsForFeatureCatalog(response: Response): Promise<Tag[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Tag[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Tag[]>(null as any)
  }

  /**
   * Adds a tag to the specified feature catalog
   * @param fcId ID of feature catalog to add tag to
   * @param tagCreateRequest The Tag to add
   * @return Tag successfully added.
   */
  addTagToFeatureCatalog(fcId: string, tagCreateRequest: TagCreateRequest): Promise<Tag> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/tags"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(tagCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddTagToFeatureCatalog(_response)
    })
  }

  protected processAddTagToFeatureCatalog(response: Response): Promise<Tag> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Tag)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          "The specified feature catalog already contains the specified tag or the feature catalog is under construction",
          status,
          _responseText,
          _headers
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Tag>(null as any)
  }

  /**
   * Remove the specified tag from the specified feature catalog
   * @param fcId Id of feature catalog to remove tag from
   * @param tag Tag to remove from feature catalog. Could be name or id of the tag
   * @return Tag successfully removed.
   */
  deleteTagFromFeatureCatalog(fcId: string, tag: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/tags/{tag}"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (tag === undefined || tag === null) throw new Error("The parameter 'tag' must be defined.")
    url_ = url_.replace("{tag}", encodeURIComponent("" + tag))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTagFromFeatureCatalog(_response)
    })
  }

  protected processDeleteTagFromFeatureCatalog(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID or the specified tag was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException("The specified feature catalog is under construction", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Publish resources for a feature catalog in the specified language by uploading a .resx file
             NB: Quadri Configuration Admins only
   * @param resxFile (optional) 
   * @return Resource file successfully updated
   */
  publishFeatureCatalogResources(
    languageCode: string,
    resxFile?: FileParameter | null | undefined
  ): Promise<PublishFCResourcesOk> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/languages/{languageCode}"
    if (languageCode === undefined || languageCode === null)
      throw new Error("The parameter 'languageCode' must be defined.")
    url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = new FormData()
    if (resxFile !== null && resxFile !== undefined)
      content_.append("resxFile", resxFile.data, resxFile.fileName ? resxFile.fileName : "resxFile")

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processPublishFeatureCatalogResources(_response)
    })
  }

  protected processPublishFeatureCatalogResources(response: Response): Promise<PublishFCResourcesOk> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PublishFCResourcesOk)
        return result200
      })
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PublishFCResourcesOk)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "User / Client is not authorized to perform this operation.",
          status,
          _responseText,
          _headers
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PublishFCResourcesOk>(null as any)
  }

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/status"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalogStatus(_response)
    })
  }

  protected processGetFeatureCatalogStatus(response: Response): Promise<FCStatusInformation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCStatusInformation)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCStatusInformation>(null as any)
  }

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/languages"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLanguages(_response)
    })
  }

  protected processGetLanguages(response: Response): Promise<Language[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Language[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Language[]>(null as any)
  }

  /**
   * List all feature type groups of the specified standard feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/featureTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroups(_response)
    })
  }

  protected processGetFeatureTypeGroups(response: Response): Promise<FeatureTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroup[]>(null as any)
  }

  /**
   * Get the specified feature type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/featureTypeGroups/{ftgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroup(_response)
    })
  }

  protected processGetFeatureTypeGroup(response: Response): Promise<FeatureTypeGroupExtended> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroupExtended)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroupExtended>(null as any)
  }

  /**
   * List all feature types in the specified feature type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/featureTypeGroups/{ftgId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypesInGroup(_response)
    })
  }

  protected processGetFeatureTypesInGroup(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * List all feature types in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypes(_response)
    })
  }

  protected processGetFeatureTypes(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * Get the specified feature type in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/featureTypes/{ftId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    if (includeInheritance === null) throw new Error("The parameter 'includeInheritance' cannot be null.")
    else if (includeInheritance !== undefined)
      url_ += "includeInheritance=" + encodeURIComponent("" + includeInheritance) + "&"
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureType(_response)
    })
  }

  protected processGetFeatureType(response: Response): Promise<FCFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCFeatureType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCFeatureType>(null as any)
  }

  /**
   * List all attribute type groups of the specified standard feature catalog
   * @param fcId ID of the feature catalog to get attribute type groups for.
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/attributeTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroups(_response)
    })
  }

  protected processGetAttributeTypeGroups(response: Response): Promise<FCAttributeTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup[]>(null as any)
  }

  /**
   * Get the specified attribute type group in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/attributeTypeGroups/{atgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroup(_response)
    })
  }

  protected processGetAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * List all attribute types in the specified attribute type group in the specified standard feature catalog
   * @param fcId ID of the feature catalog containing the attribute types
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/attributeTypeGroups/{atgId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesInGroup(_response)
    })
  }

  protected processGetAttributeTypesInGroup(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * List all attribute types in the specified standard feature catalog
   * @param fcId ID of the standard feature catalog containing the attribute types
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypes(_response)
    })
  }

  protected processGetAttributeTypes(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get the specified attribute type in the specified standard feature catalog
   * @param fcId ID of the feature catalog containing the attribute type
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType> {
    let url_ = this.baseUrl + "/api/v2/featureCatalogs/{fcId}/attributeTypes/{atId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeType(_response)
    })
  }

  protected processGetAttributeType(response: Response): Promise<FCAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeType>(null as any)
  }
}

export interface IPrivateFeatureCatalogsClient {
  /**
   * Get all private feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of private feature catalogs
   */
  getPrivateFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<PrivateFeatureCatalog[]>

  /**
   * Get the private feature catalog with the specified ID.
   * @param fcId Id of the private feature catalog to get.
   * @return The private feature catalog
   */
  getPrivateFeatureCatalog(fcId: string): Promise<PrivateFeatureCatalog>

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation>

  /**
   * Sets the status to failed for the feature catalog with the specified id and sets uri to an optional report
   * @param fcId Id of the feature catalog to get status for
   * @param statusFailedRequest Information about the failed feature catalog generation.
              The eTag must match the current feature catalog eTag
   * @return The new status information for the specified feature catalog
   */
  updateFeatureCatalogStatus(
    fcId: string,
    statusFailedRequest: FeatureCatalogStatusFailedRequest
  ): Promise<FCStatusInformation>

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]>

  /**
   * Get all private feature catalog standards that are accessible for the authenticated user and meets the specified requirements
   * @param namespaceFilter (optional) If specified, the list of private feature catalog standards are filtered by "standardFilter" field.
   * @return List of standard feature catalog standards
   */
  getStandards(namespaceFilter?: string | null | undefined): Promise<PrivateFeatureCatalogStandard[]>

  /**
   * Create a new private feature catalog standard
   * @param standardCreateRequest Information about the private feature catalog standard to create
   * @return The new Private Feature Catalog Standard
   */
  createStandard(
    standardCreateRequest: PrivateFeatureCatalogStandardCreateRequest
  ): Promise<PrivateFeatureCatalogStandard>

  /**
   * Get the private feature catalog standard with the specified id
   * @param standardId ID of private feature catalog standard (including namespace) to get
   * @return Private Feature Catalog Standard
   */
  getStandard(standardId: string): Promise<PrivateFeatureCatalogStandard>

  /**
   * Remove the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove
   * @return User role successfully removed.
   */
  deleteStandard(standardId: string): Promise<void>

  /**
   * Gets all tags for the specified private feature catalog standard
   * @param standardId Standard string (id) the private feature catalog standard to get tags for
   * @return List of tags
   */
  getTagsForPrivateFeatureCatalogStandard(standardId: string): Promise<Tag[]>

  /**
   * Adds a tag to the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to add tag to
   * @param tagCreateRequest The Tag to add
   * @return Tag successfully added.
   */
  createTagForPrivateFeatureCatalogStandard(standardId: string, tagCreateRequest: TagCreateRequest): Promise<Tag>

  /**
   * Remove the specified tag from the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove tag from
   * @param tag Tag to remove from PFC standard. Could be name or id of the tag
   * @return Tag successfully removed.
   */
  deleteTagFromPrivateFeatureCatalogStandard(standardId: string, tag: string): Promise<void>

  /**
   * Get all versions of the specified private feature catalog (standard)
   * @param standardId Id of private feature catalog standards to get versions for.
   * @return List of private feature catalogs
   */
  getVersionsOfStandard(standardId: string): Promise<PrivateFeatureCatalog[]>

  /**
   * Import a new version a private feature catalog from a file
   * @param standardId ID (including namespace) of the private feature catalog standard to make a new version of.
   * @param importFormat (optional) Optional import format string
   * @param sourceFiles (optional) File(s) to import as a new private feature catalog in the specified standard.
   * @return Reference to private feature catalog that are under construction
   */
  importPrivateFeatureCatalog(
    standardId: string,
    importFormat?: string | null | undefined,
    sourceFiles?: FileParameter[] | null | undefined
  ): Promise<PrivateFeatureCatalog>

  /**
   * Rerun import of a private feature catalog from a file that has previously failed
   * @param standardId ID (including namespace) of the private feature catalog standard to make a new version of.
   * @param fcId ID of the feature catalog that has status Failed and should be re-generated
   * @param importFormat (optional) Optional import format string
   * @param sourceFiles (optional) File(s) to import as a private feature catalog in the specified standard.
   * @return Reference to private feature catalog that are under construction
   */
  reimportPrivateFeatureCatalog(
    standardId: string,
    fcId: string,
    importFormat?: string | null | undefined,
    sourceFiles?: FileParameter[] | null | undefined
  ): Promise<PrivateFeatureCatalog>

  /**
   * Gets all user roles for the specified private feature catalog i.e. who has access to the feature catalog
   * @param standardId Standard string (id) the private feature catalog standard to get user roles for
   * @return List of user roles
   */
  getUserRolesForPrivateFeatureCatalogStandard(standardId: string): Promise<UserRole[]>

  /**
   * Adds a user role to the specified private feature catalog
   * @param standardId ID of private feature catalog standard (including namespace) to create user role for
   * @param userRoleCreateRequest Role and user information for the new user role
   * @return User role successfully removed.
   */
  createUserRoleForPrivateFeatureCatalogStandard(
    standardId: string,
    userRoleCreateRequest: UserRoleCreateRequest
  ): Promise<UserRole>

  /**
   * Gets the specified user role for the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to get user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to get
   * @return User role
   */
  getUserRoleForPrivateFeatureCatalogStandard(standardId: string, userIdOrEmail: string): Promise<UserRole>

  /**
   * Update the specified user role for the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to update user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to update
   * @param updateRequest New Role
   * @return User role successfully updated.
   */
  updateUserRoleForPrivateFeatureCatalogStandard(
    standardId: string,
    userIdOrEmail: string,
    updateRequest: UserRoleUpdateRequest
  ): Promise<UserRole>

  /**
   * Remove the specified user role from the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove user role for
   * @param userIdOrEmail Id or e-mail of user in the user role to remove
   * @return User role successfully removed.
   */
  deleteUserRoleForPrivateFeatureCatalogStandard(standardId: string, userIdOrEmail: string): Promise<void>

  /**
   * List all feature type groups of the specified private feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]>

  /**
   * Get the specified feature type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended>

  /**
   * List all feature types in the specified feature type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * List all feature types in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]>

  /**
   * Get the specified feature type in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType>

  /**
   * Get all attribute type groups in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]>

  /**
   * Create a new attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgCreateRequest Information about the attribute type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the private feature catalog
   * @return The new Attribute Type Group
   */
  createAttributeTypeGroup(
    fcId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * Get the specified attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup>

  /**
   * Get all attribute types in the specified attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(fcId: string, atgId: number, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get all attribute types in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]>

  /**
   * Get the specified attribute type in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType>
}

export class PrivateFeatureCatalogsClient implements IPrivateFeatureCatalogsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    this.http = http ? http : (window as any)
    this.baseUrl = baseUrl ?? "https://quadri-community-api-apicloud.azurewebsites.net"
  }

  /**
   * Get all private feature catalogs that are accessible for the authenticated user and meets the specified requirements
   * @param standard (optional) If specified, the list of feature catalogs are filtered by "standard" field.
   * @param minimumVersion (optional) To be used together with standard. Only feature catalogs with major version equal to and minor version equal or greater 
  than this will be included in the returned list of feature catalogs
   * @param maximumStreamVersion (optional) If specified, only feature catalogs with stream version equal to or less than this will be included;
  otherwise, only feature catalogs with default stream version will be returned.
   * @param tags (optional) Comma separated list of tags.
  If specified, only feature catalogs that has all the specified tags will be returned.
   * @param excludeFcUri (optional) If set to true, the URIs to FC files are not included in the response. Default is false
   * @return List of private feature catalogs
   */
  getPrivateFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined,
    excludeFcUri?: boolean | undefined
  ): Promise<PrivateFeatureCatalog[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs?"
    if (standard !== undefined && standard !== null) url_ += "standard=" + encodeURIComponent("" + standard) + "&"
    if (minimumVersion !== undefined && minimumVersion !== null)
      url_ += "minimumVersion=" + encodeURIComponent("" + minimumVersion) + "&"
    if (maximumStreamVersion !== undefined && maximumStreamVersion !== null)
      url_ += "maximumStreamVersion=" + encodeURIComponent("" + maximumStreamVersion) + "&"
    if (tags !== undefined && tags !== null) url_ += "tags=" + encodeURIComponent("" + tags) + "&"
    if (excludeFcUri === null) throw new Error("The parameter 'excludeFcUri' cannot be null.")
    else if (excludeFcUri !== undefined) url_ += "excludeFcUri=" + encodeURIComponent("" + excludeFcUri) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPrivateFeatureCatalogs(_response)
    })
  }

  protected processGetPrivateFeatureCatalogs(response: Response): Promise<PrivateFeatureCatalog[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalog[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalog[]>(null as any)
  }

  /**
   * Get the private feature catalog with the specified ID.
   * @param fcId Id of the private feature catalog to get.
   * @return The private feature catalog
   */
  getPrivateFeatureCatalog(fcId: string): Promise<PrivateFeatureCatalog> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetPrivateFeatureCatalog(_response)
    })
  }

  protected processGetPrivateFeatureCatalog(response: Response): Promise<PrivateFeatureCatalog> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalog)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalog>(null as any)
  }

  /**
   * Get status information for the feature catalog with the specified id
   * @param fcId Id of the feature catalog to get status for
   * @return Status information of specified feature catalog
   */
  getFeatureCatalogStatus(fcId: string): Promise<FCStatusInformation> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/status"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureCatalogStatus(_response)
    })
  }

  protected processGetFeatureCatalogStatus(response: Response): Promise<FCStatusInformation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCStatusInformation)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCStatusInformation>(null as any)
  }

  /**
   * Sets the status to failed for the feature catalog with the specified id and sets uri to an optional report
   * @param fcId Id of the feature catalog to get status for
   * @param statusFailedRequest Information about the failed feature catalog generation.
              The eTag must match the current feature catalog eTag
   * @return The new status information for the specified feature catalog
   */
  updateFeatureCatalogStatus(
    fcId: string,
    statusFailedRequest: FeatureCatalogStatusFailedRequest
  ): Promise<FCStatusInformation> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/status"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(statusFailedRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateFeatureCatalogStatus(_response)
    })
  }

  protected processUpdateFeatureCatalogStatus(response: Response): Promise<FCStatusInformation> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCStatusInformation)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The request could not be executed due to eTag mismatch",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCStatusInformation>(null as any)
  }

  /**
   * Gets all languages that the specified feature catalog is translated to
   * @param fcId Id of the feature catalog to get languages for
   * @return List of languages
   */
  getLanguages(fcId: string): Promise<Language[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/languages"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLanguages(_response)
    })
  }

  protected processGetLanguages(response: Response): Promise<Language[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Language[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Language[]>(null as any)
  }

  /**
   * Get all private feature catalog standards that are accessible for the authenticated user and meets the specified requirements
   * @param namespaceFilter (optional) If specified, the list of private feature catalog standards are filtered by "standardFilter" field.
   * @return List of standard feature catalog standards
   */
  getStandards(namespaceFilter?: string | null | undefined): Promise<PrivateFeatureCatalogStandard[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards?"
    if (namespaceFilter !== undefined && namespaceFilter !== null)
      url_ += "namespaceFilter=" + encodeURIComponent("" + namespaceFilter) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStandards(_response)
    })
  }

  protected processGetStandards(response: Response): Promise<PrivateFeatureCatalogStandard[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalogStandard[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalogStandard[]>(null as any)
  }

  /**
   * Create a new private feature catalog standard
   * @param standardCreateRequest Information about the private feature catalog standard to create
   * @return The new Private Feature Catalog Standard
   */
  createStandard(
    standardCreateRequest: PrivateFeatureCatalogStandardCreateRequest
  ): Promise<PrivateFeatureCatalogStandard> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards"
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(standardCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateStandard(_response)
    })
  }

  protected processCreateStandard(response: Response): Promise<PrivateFeatureCatalogStandard> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalogStandard)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "Can not create duplicate feature catalog standards",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalogStandard>(null as any)
  }

  /**
   * Get the private feature catalog standard with the specified id
   * @param standardId ID of private feature catalog standard (including namespace) to get
   * @return Private Feature Catalog Standard
   */
  getStandard(standardId: string): Promise<PrivateFeatureCatalogStandard> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetStandard(_response)
    })
  }

  protected processGetStandard(response: Response): Promise<PrivateFeatureCatalogStandard> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalogStandard)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalogStandard>(null as any)
  }

  /**
   * Remove the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove
   * @return User role successfully removed.
   */
  deleteStandard(standardId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteStandard(_response)
    })
  }

  protected processDeleteStandard(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not remove feature catalog standard", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Gets all tags for the specified private feature catalog standard
   * @param standardId Standard string (id) the private feature catalog standard to get tags for
   * @return List of tags
   */
  getTagsForPrivateFeatureCatalogStandard(standardId: string): Promise<Tag[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/tags"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetTagsForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processGetTagsForPrivateFeatureCatalogStandard(response: Response): Promise<Tag[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Tag[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Tag[]>(null as any)
  }

  /**
   * Adds a tag to the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to add tag to
   * @param tagCreateRequest The Tag to add
   * @return Tag successfully added.
   */
  createTagForPrivateFeatureCatalogStandard(standardId: string, tagCreateRequest: TagCreateRequest): Promise<Tag> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/tags"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(tagCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateTagForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processCreateTagForPrivateFeatureCatalogStandard(response: Response): Promise<Tag> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Tag)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not create duplicate tag", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<Tag>(null as any)
  }

  /**
   * Remove the specified tag from the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove tag from
   * @param tag Tag to remove from PFC standard. Could be name or id of the tag
   * @return Tag successfully removed.
   */
  deleteTagFromPrivateFeatureCatalogStandard(standardId: string, tag: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/tags/{tag}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (tag === undefined || tag === null) throw new Error("The parameter 'tag' must be defined.")
    url_ = url_.replace("{tag}", encodeURIComponent("" + tag))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteTagFromPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processDeleteTagFromPrivateFeatureCatalogStandard(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID or the specified tag was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * Get all versions of the specified private feature catalog (standard)
   * @param standardId Id of private feature catalog standards to get versions for.
   * @return List of private feature catalogs
   */
  getVersionsOfStandard(standardId: string): Promise<PrivateFeatureCatalog[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/versions"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetVersionsOfStandard(_response)
    })
  }

  protected processGetVersionsOfStandard(response: Response): Promise<PrivateFeatureCatalog[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalog[])
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalog[]>(null as any)
  }

  /**
   * Import a new version a private feature catalog from a file
   * @param standardId ID (including namespace) of the private feature catalog standard to make a new version of.
   * @param importFormat (optional) Optional import format string
   * @param sourceFiles (optional) File(s) to import as a new private feature catalog in the specified standard.
   * @return Reference to private feature catalog that are under construction
   */
  importPrivateFeatureCatalog(
    standardId: string,
    importFormat?: string | null | undefined,
    sourceFiles?: FileParameter[] | null | undefined
  ): Promise<PrivateFeatureCatalog> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/versions?"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (sourceFiles !== undefined && sourceFiles !== null)
      sourceFiles &&
        sourceFiles.forEach((item) => {
          url_ += "sourceFiles=" + encodeURIComponent("" + item) + "&"
        })
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "POST",
      headers: {
        "import-format": importFormat !== undefined && importFormat !== null ? "" + importFormat : "",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processImportPrivateFeatureCatalog(_response)
    })
  }

  protected processImportPrivateFeatureCatalog(response: Response): Promise<PrivateFeatureCatalog> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalog)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "Cannot make a new version of private feature catalog while the previous version is still under construction.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalog>(null as any)
  }

  /**
   * Rerun import of a private feature catalog from a file that has previously failed
   * @param standardId ID (including namespace) of the private feature catalog standard to make a new version of.
   * @param fcId ID of the feature catalog that has status Failed and should be re-generated
   * @param importFormat (optional) Optional import format string
   * @param sourceFiles (optional) File(s) to import as a private feature catalog in the specified standard.
   * @return Reference to private feature catalog that are under construction
   */
  reimportPrivateFeatureCatalog(
    standardId: string,
    fcId: string,
    importFormat?: string | null | undefined,
    sourceFiles?: FileParameter[] | null | undefined
  ): Promise<PrivateFeatureCatalog> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/versions/{fcId}?"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (sourceFiles !== undefined && sourceFiles !== null)
      sourceFiles &&
        sourceFiles.forEach((item) => {
          url_ += "sourceFiles=" + encodeURIComponent("" + item) + "&"
        })
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "PUT",
      headers: {
        "import-format": importFormat !== undefined && importFormat !== null ? "" + importFormat : "",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processReimportPrivateFeatureCatalog(_response)
    })
  }

  protected processReimportPrivateFeatureCatalog(response: Response): Promise<PrivateFeatureCatalog> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 202) {
      return response.text().then((_responseText) => {
        let result202: any = null
        result202 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PrivateFeatureCatalog)
        return result202
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "Cannot make a new version of private feature catalog while the previous version is still under construction.",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<PrivateFeatureCatalog>(null as any)
  }

  /**
   * Gets all user roles for the specified private feature catalog i.e. who has access to the feature catalog
   * @param standardId Standard string (id) the private feature catalog standard to get user roles for
   * @return List of user roles
   */
  getUserRolesForPrivateFeatureCatalogStandard(standardId: string): Promise<UserRole[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/users"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRolesForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processGetUserRolesForPrivateFeatureCatalogStandard(response: Response): Promise<UserRole[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole[]>(null as any)
  }

  /**
   * Adds a user role to the specified private feature catalog
   * @param standardId ID of private feature catalog standard (including namespace) to create user role for
   * @param userRoleCreateRequest Role and user information for the new user role
   * @return User role successfully removed.
   */
  createUserRoleForPrivateFeatureCatalogStandard(
    standardId: string,
    userRoleCreateRequest: UserRoleCreateRequest
  ): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/users"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(userRoleCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateUserRoleForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processCreateUserRoleForPrivateFeatureCatalogStandard(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result201
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog standard with the specified ID or user role for the user with specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not create duplicate user roles", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Gets the specified user role for the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to get user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to get
   * @return User role
   */
  getUserRoleForPrivateFeatureCatalogStandard(standardId: string, userIdOrEmail: string): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/users/{userIdOrEmail}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetUserRoleForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processGetUserRoleForPrivateFeatureCatalogStandard(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Update the specified user role for the specified private feature catalog standard
   * @param standardId ID of private feature catalog standard (including namespace) to update user roles for
   * @param userIdOrEmail Id or e-mail of user in the user role to update
   * @param updateRequest New Role
   * @return User role successfully updated.
   */
  updateUserRoleForPrivateFeatureCatalogStandard(
    standardId: string,
    userIdOrEmail: string,
    updateRequest: UserRoleUpdateRequest
  ): Promise<UserRole> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/users/{userIdOrEmail}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(updateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateUserRoleForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processUpdateUserRoleForPrivateFeatureCatalogStandard(response: Response): Promise<UserRole> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserRole)
        return result200
      })
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null
        result400 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails)
        return throwException("Bad request. One or more validation errors.", status, _responseText, _headers, result400)
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not update user role for owner", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<UserRole>(null as any)
  }

  /**
   * Remove the specified user role from the specified private feature catalog standard
   * @param standardId Id of private feature catalog standard (including namespace) to remove user role for
   * @param userIdOrEmail Id or e-mail of user in the user role to remove
   * @return User role successfully removed.
   */
  deleteUserRoleForPrivateFeatureCatalogStandard(standardId: string, userIdOrEmail: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/standards/{standardId}/users/{userIdOrEmail}"
    if (standardId === undefined || standardId === null) throw new Error("The parameter 'standardId' must be defined.")
    url_ = url_.replace("{standardId}", encodeURIComponent("" + standardId))
    if (userIdOrEmail === undefined || userIdOrEmail === null)
      throw new Error("The parameter 'userIdOrEmail' must be defined.")
    url_ = url_.replace("{userIdOrEmail}", encodeURIComponent("" + userIdOrEmail))
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "DELETE",
      headers: {}
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processDeleteUserRoleForPrivateFeatureCatalogStandard(_response)
    })
  }

  protected processDeleteUserRoleForPrivateFeatureCatalogStandard(response: Response): Promise<void> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to modify this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog standard with the specified ID or user role for the user with specified ID or e-mail was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException("Can not remove user role for owner", status, _responseText, _headers, result405)
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<void>(null as any)
  }

  /**
   * List all feature type groups of the specified private feature catalog
   * @param fcId ID of the feature catalog to get feature type groups for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature type groups
   */
  getFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/featureTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroups(_response)
    })
  }

  protected processGetFeatureTypeGroups(response: Response): Promise<FeatureTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroup[]>(null as any)
  }

  /**
   * Get the specified feature type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftgId ID of the feature type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The feature type group
   */
  getFeatureTypeGroup(
    fcId: string,
    ftgId: number,
    language?: string | null | undefined
  ): Promise<FeatureTypeGroupExtended> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypeGroup(_response)
    })
  }

  protected processGetFeatureTypeGroup(response: Response): Promise<FeatureTypeGroupExtended> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureTypeGroupExtended)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureTypeGroupExtended>(null as any)
  }

  /**
   * List all feature types in the specified feature type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftgId ID of the feature type group to get feature types for
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypesInGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/featureTypeGroups/{ftgId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftgId === undefined || ftgId === null) throw new Error("The parameter 'ftgId' must be defined.")
    url_ = url_.replace("{ftgId}", encodeURIComponent("" + ftgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypesInGroup(_response)
    })
  }

  protected processGetFeatureTypesInGroup(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * List all feature types in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of feature types
   */
  getFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/featureTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureTypes(_response)
    })
  }

  protected processGetFeatureTypes(response: Response): Promise<FeatureType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FeatureType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FeatureType[]>(null as any)
  }

  /**
   * Get the specified feature type in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param ftId ID of the feature type to get
   * @param includeInheritance (optional) If set to true, the response will contain the inheritance chain (ordered list of feature type references)
   * @param language (optional) Specify language code for translated texts
   * @return The feature type
   */
  getFeatureType(
    fcId: string,
    ftId: number,
    includeInheritance?: boolean | undefined,
    language?: string | null | undefined
  ): Promise<FCFeatureType> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/featureTypes/{ftId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (ftId === undefined || ftId === null) throw new Error("The parameter 'ftId' must be defined.")
    url_ = url_.replace("{ftId}", encodeURIComponent("" + ftId))
    if (includeInheritance === null) throw new Error("The parameter 'includeInheritance' cannot be null.")
    else if (includeInheritance !== undefined)
      url_ += "includeInheritance=" + encodeURIComponent("" + includeInheritance) + "&"
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetFeatureType(_response)
    })
  }

  protected processGetFeatureType(response: Response): Promise<FCFeatureType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCFeatureType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCFeatureType>(null as any)
  }

  /**
   * Get all attribute type groups in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute type groups
   */
  getAttributeTypeGroups(fcId: string, language?: string | null | undefined): Promise<FCAttributeTypeGroup[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypeGroups?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroups(_response)
    })
  }

  protected processGetAttributeTypeGroups(response: Response): Promise<FCAttributeTypeGroup[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup[]>(null as any)
  }

  /**
   * Create a new attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgCreateRequest Information about the attribute type group to create.
  The name will be compared with groups in previous version in order to reuse ID.
  If ID is present in this request, the name must match the ID in previous version.
   * @param fcEtag (optional) Current ETag of the private feature catalog
   * @return The new Attribute Type Group
   */
  createAttributeTypeGroup(
    fcId: string,
    atgCreateRequest: AttributeTypeGroupCreateRequestWithId,
    fcEtag?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypeGroups"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    url_ = url_.replace(/[?&]$/, "")

    const content_ = JSON.stringify(atgCreateRequest)

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "fc-etag": fcEtag !== undefined && fcEtag !== null ? "" + fcEtag : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processCreateAttributeTypeGroup(_response)
    })
  }

  protected processCreateAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null
        result201 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result201
      })
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The private feature catalog with the specified ID was not found.",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status === 405) {
      return response.text().then((_responseText) => {
        let result405: any = null
        result405 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The specified private feature catalog can not be updated (it is not in 'under construction' state).",
          status,
          _responseText,
          _headers,
          result405
        )
      })
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        let result409: any = null
        result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The create request could not be executed due to eTag mismatch or duplicate name or duplicate ID",
          status,
          _responseText,
          _headers,
          result409
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * Get the specified attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgId ID of the attribute type group to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type group
   */
  getAttributeTypeGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<FCAttributeTypeGroup> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypeGroup(_response)
    })
  }

  protected processGetAttributeTypeGroup(response: Response): Promise<FCAttributeTypeGroup> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 =
          _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeTypeGroup)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeTypeGroup>(null as any)
  }

  /**
   * Get all attribute types in the specified attribute type group in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atgId ID of the attribute type group
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypesInGroup(
    fcId: string,
    atgId: number,
    language?: string | null | undefined
  ): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypeGroups/{atgId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atgId === undefined || atgId === null) throw new Error("The parameter 'atgId' must be defined.")
    url_ = url_.replace("{atgId}", encodeURIComponent("" + atgId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypesInGroup(_response)
    })
  }

  protected processGetAttributeTypesInGroup(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type group or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get all attribute types in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param language (optional) Specify language code for translated texts
   * @return List of attribute types
   */
  getAttributeTypes(fcId: string, language?: string | null | undefined): Promise<AttributeType[]> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypes?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeTypes(_response)
    })
  }

  protected processGetAttributeTypes(response: Response): Promise<AttributeType[]> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as AttributeType[])
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<AttributeType[]>(null as any)
  }

  /**
   * Get the specified attribute type in the specified private feature catalog
   * @param fcId ID of the private feature catalog
   * @param atId ID of the attribute type to get
   * @param language (optional) Specify language code for translated texts
   * @return The attribute type
   */
  getAttributeType(fcId: string, atId: number, language?: string | null | undefined): Promise<FCAttributeType> {
    let url_ = this.baseUrl + "/api/v2/privateFeatureCatalogs/{fcId}/attributeTypes/{atId}?"
    if (fcId === undefined || fcId === null) throw new Error("The parameter 'fcId' must be defined.")
    url_ = url_.replace("{fcId}", encodeURIComponent("" + fcId))
    if (atId === undefined || atId === null) throw new Error("The parameter 'atId' must be defined.")
    url_ = url_.replace("{atId}", encodeURIComponent("" + atId))
    if (language !== undefined && language !== null) url_ += "language=" + encodeURIComponent("" + language) + "&"
    url_ = url_.replace(/[?&]$/, "")

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAttributeType(_response)
    })
  }

  protected processGetAttributeType(response: Response): Promise<FCAttributeType> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v))
    }
    if (status === 403) {
      return response.text().then((_responseText) => {
        let result403: any = null
        result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "User is not authorized to access this resource.",
          status,
          _responseText,
          _headers,
          result403
        )
      })
    } else if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null
        result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FCAttributeType)
        return result200
      })
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Authorization information is missing or invalid.", status, _responseText, _headers)
      })
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null
        result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails)
        return throwException(
          "The attribute type or feature catalog with the specified ID could not be found",
          status,
          _responseText,
          _headers,
          result404
        )
      })
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers)
      })
    }
    return Promise.resolve<FCAttributeType>(null as any)
  }
}

export interface FeatureCatalogBase {
  id: string
  persistentId: number
  name: string
  standard: string
  version: string
  date: string
  streamVersion?: string | undefined
}

export interface FeatureCatalog extends FeatureCatalogBase {
  blobStorageUri?: string | undefined
  availableTranslations?: FeatureCatalogTranslation[] | undefined
  sqLiteUri?: string | undefined
  blobStorageQfcUri?: string | undefined
  tags?: Tag[] | undefined
}

export interface FeatureCatalogCommon extends FeatureCatalog {
  displayText: string | undefined
}

export interface AnyFeatureCatalog extends FeatureCatalogCommon {
  category: FeatureCatalogCategories
  basedOnStandards?: FeatureCatalogStandard[] | undefined
  customizationId?: string | undefined
  customizationVersion?: number
}

export enum FeatureCatalogCategories {
  Standard = "Standard",
  Private = "Private",
  Custom = "Custom"
}

export interface FeatureCatalogStandard {
  standard: string
  version: string
}

export interface FeatureCatalogTranslation {
  languageCode?: string | undefined
  blobStorageUri?: string | undefined
}

export interface Tag {
  id?: string | undefined
  name?: string | undefined
}

export interface ProblemDetails {
  type?: string | undefined
  title?: string | undefined
  status?: number | undefined
  detail?: string | undefined
  instance?: string | undefined
  extensions?: { [key: string]: any }

  [key: string]: any
}

export interface HttpValidationProblemDetails extends ProblemDetails {
  errors?: { [key: string]: string[] }

  [key: string]: any
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
  errors?: { [key: string]: string[] }

  [key: string]: any
}

export interface AnyFeatureCatalogInfo extends FeatureCatalogBase {
  category?: FeatureCatalogCategories
  displayText: string | undefined
}

export interface FCStatusInformation {
  attributeTypeGroupCount?: number | undefined
  attributeTypeCount?: number | undefined
  featureTypeGroupCount?: number | undefined
  featureTypeCount?: number | undefined
  status: FeatureCatalogStatus
  reportUri?: string | undefined
  failedReason?: string | undefined
  lastTouchedAt?: Date | undefined
}

export enum FeatureCatalogStatus {
  Undefined = "Undefined",
  UnderConstruction = "UnderConstruction",
  Failed = "Failed",
  Published = "Published"
}

export interface Language {
  code: string | undefined
  DisplayName?: string | undefined
}

/** Represents the result of a type search operation */
export interface TypeSearchResult {
  /** The list of items that makes up the result of the search operation */
  items: TypeItem[]
  /** Contains pagination information about the current request. */
  pagination: Pagination
}

export interface TypeItem {
  /** ID of the type */
  id: number
  /** Name of the type  */
  name: string
  /** The kind of type this TypeItem represents */
  category: TypeCategories
}

export enum TypeCategories {
  FeatureTypeGroup = "FeatureTypeGroup",
  FeatureType = "FeatureType",
  AttributeTypeGroup = "AttributeTypeGroup",
  AttributeType = "AttributeType"
}

export interface Pagination {
  /** The total number of items available for the current request */
  total: number
  /** The number of items returned in the current page */
  returned: number
  /** The size of a page (maximum number of items returned in a single request) */
  pageSize: number
  /** Offset of the first returned item within the list of all matching items */
  offset?: number
}

export interface FeatureTypeGroupSimpleBase {
  name: string
  description?: string | undefined
  shortName?: string | undefined
  no?: number
}

export interface FeatureTypeGroup extends FeatureTypeGroupSimpleBase {
  id: number
  containsTypes?: boolean
}

export interface FeatureTypeGroupExtended extends FeatureTypeGroup {
  featureTypeIds?: number[] | undefined
}

export interface FeatureTypeBase {
  /** Name of the feature type */
  name: string
  /** Description of the feature type */
  description?: string | undefined
  /** Ordering number for the feature type. */
  no?: number
  /** ID of a feature type to be used as super type for this feature type */
  superTypeId?: number | undefined
  /** If true, this feature type can not be instantiated, but can be used as super type for other feature types. */
  isAbstract?: boolean
}

export interface FeatureTypeSimple extends FeatureTypeBase {
  /** List of feature type groups that this feature type belongs to. */
  groups?: FeatureTypeGroupAffiliation[] | undefined
}

export interface FeatureType extends FeatureTypeSimple {
  /** Persistent ID for this feature type */
  id: number
}

export interface FeatureTypeGroupAffiliation {
  groupId: number
  primary?: boolean
  no?: number
}

export interface FeatureTypeExtended extends FeatureType {
  attributeTypes?: AttributeTypeContext[] | undefined
}

export interface FCFeatureType extends FeatureTypeExtended {
  /** Ordered list of feature types that makes up the inheritance chain for the current feature type. */
  inheritanceChain?: FeatureTypeReferenceSimple[] | undefined
  /** List of attribute types defined for the super types of this feature type */
  inheritedAttributeTypes?: AttributeTypeContext[] | undefined
  /** List of associations to and from this feature type */
  associations?: AssociationDetails[] | undefined
}

export interface FeatureTypeReferenceSimple {
  featureTypeId: number
  featureTypeName?: string | undefined
}

/** The usage context where a attribute type is used by a feature type */
export interface AttributeTypeContext {
  /** Id of the attribute type specified */
  attributeTypeId: number
  /** Name of the attribute type specified */
  name?: string | undefined
  /** Data type of the specified attribute type */
  dataType?: AttributeDataTypes | undefined
  /** Ordering number of the attribute type within the feature type */
  no?: number
  /** Textual description of the usage of the attribute type for the current feature type */
  description?: string | undefined
  /** List of constraints to be used for the attribute type in this context
(subset of the constraints defined for the attribute type) */
  constraints?: number[] | undefined
}

export enum AttributeDataTypes {
  Unknown = "Unknown",
  String = "String",
  Integer = "Integer",
  Real = "Real",
  Point = "Point",
  Curve = "Curve",
  Surface = "Surface",
  Solid = "Solid",
  Annotation = "Annotation",
  MultiPoint = "MultiPoint",
  MultiCurve = "MultiCurve",
  MultiSurface = "MultiSurface",
  MultiSolid = "MultiSolid",
  Measure = "Measure",
  Bool = "Bool",
  Blob = "Blob",
  Char = "Char",
  Date = "Date",
  DateTime = "DateTime",
  ShortDate = "ShortDate",
  Time = "Time",
  Spatial = "Spatial",
  Struct = "Struct",
  Locational = "Locational",
  Association = "Association",
  List = "List"
}

/** Extra attribute type content for association attribute types */
export interface AssociationContent {
  /** Type of affiliation for this association */
  affiliation?: AffiliationTypes
  /** Reference to the feature type this association is for */
  featureType?: FeatureTypeReferenceSimple | undefined
}

/** Details about an association */
export interface AssociationDetails extends AssociationContent {
  /** Id of the attribute type that defines this association */
  attributeTypeId?: number
  /** Name of the attribute type that defines this association */
  attributeTypeName?: string | undefined
  /** True, if the association is from another feature type to this one; otherwise,
this association is from the owning feature type to the feature type described in the association. */
  isParentAssociation?: boolean
}

/** Types of affiliation that is possible for an association attribute type */
export enum AffiliationTypes {
  AffiliationNull = "AffiliationNull",
  Association = "Association",
  Aggregation = "Aggregation",
  Composition = "Composition",
  Topology = "Topology"
}

export interface FCAttributeTypeGroup {
  id: number
  name: string
  shortName?: string | undefined
  no?: number
  description?: string | undefined
}

export interface AttributeTypeSimpleBase {
  name: string
  caption: string
  dataType: AttributeDataTypes
  description?: string | undefined
  shortName?: string | undefined
  defaultValue?: string | undefined
  minValue?: string | undefined
  maxValue?: string | undefined
  no?: number
  mandatory?: boolean
  readOnly?: boolean
  derived?: boolean
  /** Number of decimals to be shown for attribute types of DataType Real */
  numberOfDecimals?: number | undefined
  /** Type of measure to be used for attribute types of DataType Measure */
  measureType?: MeasureTypes | undefined
}

export interface AttributeType extends AttributeTypeSimpleBase {
  id: number
  hasLegalValues?: boolean
}

export enum MeasureTypes {
  Coordinate = "Coordinate",
  Length = "Length",
  MassWeight = "MassWeight",
  Time = "Time",
  GpsTime = "GpsTime",
  Azimuth = "Azimuth",
  Pressure = "Pressure",
  Volume = "Volume",
  Area = "Area",
  Energy = "Energy",
  RoughnessIndex = "RoughnessIndex",
  ElectricCurrent = "ElectricCurrent",
  LuminousIntensity = "LuminousIntensity",
  CelsiusTemperature = "CelsiusTemperature",
  ThermodynamicTemperature = "ThermodynamicTemperature",
  AmountOfSubstance = "AmountOfSubstance",
  AbsorbedDose = "AbsorbedDose",
  DoseEquivalent = "DoseEquivalent",
  ElectricCapacitance = "ElectricCapacitance",
  ElectricCharge = "ElectricCharge",
  ElectricConductance = "ElectricConductance",
  ElectricResistance = "ElectricResistance",
  ElectricVoltage = "ElectricVoltage",
  Force = "Force",
  Frequency = "Frequency",
  Illuminance = "Illuminance",
  Inductance = "Inductance",
  LuminousFlux = "LuminousFlux",
  MagneticFluxDensity = "MagneticFluxDensity",
  MagneticFlux = "MagneticFlux",
  PlanAngle = "PlanAngle",
  Power = "Power",
  Radioactivity = "Radioactivity",
  SolidAngle = "SolidAngle",
  Acceleration = "Acceleration",
  AngularVelocity = "AngularVelocity",
  AreaDensity = "AreaDensity",
  Curvature = "Curvature",
  DynamicViscosity = "DynamicViscosity",
  HeatFluxDensity = "HeatFluxDensity",
  HeatingValue = "HeatingValue",
  IntegerCountRate = "IntegerCountRate",
  IonConcentration = "IonConcentration",
  IsotermalMoistureCapacity = "IsotermalMoistureCapacity",
  KinematicViscosity = "KinematicViscosity",
  LinearForce = "LinearForce",
  LinearMoment = "LinearMoment",
  LinearStiffness = "LinearStiffness",
  LinearVelocity = "LinearVelocity",
  MassDensity = "MassDensity",
  MassFlowRate = "MassFlowRate",
  MassPerLength = "MassPerLength",
  ModulusOfElasticity = "ModulusOfElasticity",
  ModulusOfLinearSubgradeReaction = "ModulusOfLinearSubgradeReaction",
  ModulusOfRotationalSubgradeReaction = "ModulusOfRotationalSubgradeReaction",
  ModulusOfSubgradeReaction = "ModulusOfSubgradeReaction",
  MoistureDiffusivity = "MoistureDiffusivity",
  MolecularWeight = "MolecularWeight",
  Momentofinertia = "Momentofinertia",
  PH = "PH",
  PlanarForce = "PlanarForce",
  RotationalFrequency = "RotationalFrequency",
  RotationalMass = "RotationalMass",
  RotationalStiffness = "RotationalStiffness",
  SectionalAreaIntegral = "SectionalAreaIntegral",
  SectionModulus = "SectionModulus",
  ShearModulus = "ShearModulus",
  SpecificHeatcapacity = "SpecificHeatcapacity",
  ThermalAdmittance = "ThermalAdmittance",
  ThermalConductivity = "ThermalConductivity",
  ThermalResistance = "ThermalResistance",
  ThermalTransmittance = "ThermalTransmittance",
  Torque = "Torque",
  VaporPermeability = "VaporPermeability",
  VolumetricFlowrate = "VolumetricFlowrate",
  WarpingMoment = "WarpingMoment",
  Ratio = "Ratio",
  SoundPressureLevel = "SoundPressureLevel",
  CatalyticActivity = "CatalyticActivity",
  Count = "Count",
  ElectricConductivity = "ElectricConductivity",
  RateOfPenetration = "RateOfPenetration",
  Rating = "Rating",
  LugeonHydraulicConductivity = "LugeonHydraulicConductivity",
  CountPerLength = "CountPerLength",
  CountPerVolume = "CountPerVolume",
  AmountOfMonetary = "AmountOfMonetary",
  AmountOfMonetaryPerUnit = "AmountOfMonetaryPerUnit",
  AmountOfMonetaryPerMass = "AmountOfMonetaryPerMass",
  AmountOfMonetaryPerVolume = "AmountOfMonetaryPerVolume",
  AmountOfMonetaryPerArea = "AmountOfMonetaryPerArea",
  AmountOfMonetaryPerLength = "AmountOfMonetaryPerLength"
}

export interface AttributeTypeExtended extends AttributeType {
  hasLegalValues?: boolean
  legalValues?: LegalAttributeValue[] | undefined
}

export interface FCAttributeType extends AttributeTypeExtended {
  /** Specific content for attribute types with data type Association */
  associationContent?: AssociationContent | undefined
  /** Specific content for attribute types with data type Struct */
  structContent?: AttributeTypeReference[] | undefined
  /** Specific content for attribute types with data type List */
  listContent?: AttributeTypeReference | undefined
  /** Specific content for attribute types with data type Locational */
  locationalContent?: LocationalContent | undefined
}

/** Reference to an attribute type */
export interface AttributeTypeReference {
  /** ID of the referenced attribute type */
  id?: number
  /** Name of the referenced attribute type */
  name?: string | undefined
  /** Data type of the referenced attribute type */
  dataType?: AttributeDataTypes
}

/** Extra content for attribute types with data type Locational */
export interface LocationalContent {
  typeOfExtent?: TypesOfExtent
  complete?: string | undefined
  direction?: boolean
  heightLevel?: boolean
  insideParent?: boolean
  overlap?: boolean
  sidePosition?: boolean
  transferBetweenLevels?: boolean
  updateDivide?: UpdateDivide
  updateI?: UpdateI
  updateLength?: number
}

export enum TypesOfExtent {
  NetnodeExtent = "NetnodeExtent",
  PointExtent = "PointExtent",
  NetnodeOrPointExtent = "NetnodeOrPointExtent",
  LineExtent = "LineExtent",
  TurnExtent = "TurnExtent"
}

export enum UpdateDivide {
  CannotBeDivided = "CannotBeDivided",
  MayBeDivided = "MayBeDivided",
  DontKnowDivide = "DontKnowDivide"
}

export enum UpdateI {
  DontSurvive = "DontSurvive",
  Survive = "Survive",
  DontKnowI = "DontKnowI"
}

export interface LegalAttributeValue {
  id?: number
  introducedInVersion?: number
  value: string
  caption: string
  description?: string | undefined
  no?: number
}

export interface AttributeTypeGroupSimpleBase {
  name: string
  description?: string | undefined
  no?: number
}

export interface AttributeTypeGroupCreateRequestWithId extends AttributeTypeGroupSimpleBase {
  id?: number
  shortName?: string | undefined
}

export interface AttributeTypeCreateRequest extends AttributeTypeSimpleBase {}

export interface FCAttributeTypeCreateRequest extends AttributeTypeCreateRequest {
  id?: number
  legalValues?: LegalAttributeValue[] | undefined
  associationContent?: AssociationContent | undefined
  structContent?: AttributeTypeReference[] | undefined
  listContent?: AttributeTypeReference | undefined
  locationalContent?: LocationalContent | undefined
}

export interface FeatureTypeGroupCreateRequest extends FeatureTypeGroupSimpleBase {}

export interface FeatureTypeGroupCreateRequestWithId extends FeatureTypeGroupCreateRequest {
  id?: number
}

/** Data for creating a new feature type */
export interface FeatureTypeCreateRequest extends FeatureTypeSimple {}

export interface FCFeatureTypeCreateRequest extends FeatureTypeCreateRequest {
  persistentId?: number
  attributeTypes?: AttributeTypeContext[] | undefined
  /** List of associations to and from this feature type */
  associations?: AssociationDetails[] | undefined
}

export interface CDMPropertySet {
  trimbleConnectProjectName?: string | undefined
  trimbleConnectProjectDescription?: string | undefined
  trimbleConnectProjectLocation?: string | undefined
  trimbleConnectProjectId?: string | undefined
  library?: Library[] | undefined
}

export interface Library {
  name?: string | undefined
  description?: string | undefined
  id?: string | undefined
  propertySet?: PropertySet[] | undefined
}

export interface PropertySet {
  id?: string | undefined
  name?: string | undefined
  description?: string | undefined
}

export interface CDMPropertySetProperty {
  name?: string | undefined
  type?: string | undefined
  enum?: string[] | undefined
}

export interface ClassificationHeader {
  id: string
  name?: string | undefined
  type?: string | undefined
  description?: string | undefined
}

export interface Classification extends ClassificationHeader {
  modifiedAt: Date
  modifiedBy: string | undefined
  createdAt: Date
  createdBy: string | undefined
}

export interface ClassificationOfClassificationCategoryExtended extends Classification {
  version?: string | undefined
  categories: ClassificationCategoryExtended[] | undefined
}

export interface ClassificationFullOfClassificationCategoryExtended
  extends ClassificationOfClassificationCategoryExtended {
  structure: ClassificationNode[] | undefined
}

/** Represents a node in a generic classification structure */
export interface ClassificationNode {
  /** Mandatory alphanumeric code for the node */
  code: string | undefined
  /** Mandatory name of the classification node */
  name: string | undefined
  /** Optional identifier for the classification node */
  id?: string | undefined
  /** Optional description of the classification node */
  description?: string | undefined
  descriptionUrl?: string | undefined
  detailsLink?: string | undefined
  /** Mandatory category reference. The classification node must be in one of the categories defines in the classification */
  categoryIdentifier: string | undefined
  /** Optional title (name) of the category.  */
  categoryTitle?: string | undefined
  /** Child nodes of this node */
  children?: ClassificationNode[] | undefined
}

export interface ClassificationCategory {
  identifier: string
  title?: string | undefined
}

export interface ClassificationCategoryExtended extends ClassificationCategory {
  description?: string | undefined
}

export interface CoClassCreateRequest {
  structureKey: string
  structureId: number
  language: string
}

export interface ConversionRuleBase {
  id: string
  name: string
  description?: string | undefined
  sourceFeatureCatalog: FeatureCatalogReference
  destinationFeatureCatalog: FeatureCatalogReference
}

export interface ConversionRule extends ConversionRuleBase {
  myRole?: Roles
}

export enum Roles {
  Owner = "Owner",
  Editor = "Editor",
  Viewer = "Viewer"
}

export interface FeatureCatalogReference {
  id: string
  persistentId?: number
  displayText?: string | undefined
  standard?: string | undefined
  version?: string | undefined
  streamVersion?: string | undefined
}

export interface ConversionRuleSimple {
  /** Name of the conversion rule */
  name: string
  /** Description of the conversion rule (optional) */
  description?: string | undefined
  /** Id of the feature catalog that the conversion should be converting from */
  sourceFeatureCatalogId: number
  /** Id of the feature catalog that the conversion should be converting to */
  destinationFeatureCatalogId: number
}

export interface ConversionRuleCreateRequest extends ConversionRuleSimple {}

export interface ConversionRuleUpdateRequest extends ConversionRuleSimple {}

export interface CustomFeatureCatalog extends FeatureCatalogCommon {
  basedOnStandards?: FeatureCatalogStandard[] | undefined
  customizationId: string
  customizationVersion: number
}

export interface FCCustomizationReference {
  customizationId: string
  customizationVersion: number
}

export interface CustomFeatureCatalogSimple extends FeatureCatalogBase {
  basedOnStandards?: FeatureCatalogStandard[] | undefined
  customizationId: string
  customizationVersion: number
}

export interface FCCustomizationCombinedBase {
  name: string
  description?: string | undefined
  streamVersion?: string | undefined
  baseFeatureCatalogs: FeatureCatalogReference[]
}

export interface FCCustomizationCombined extends FCCustomizationCombinedBase {
  customizationId?: string | undefined
  version?: number
  status?: CustomizationStatus
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  publishedFeatureCatalog?: FeatureCatalogReference | undefined
  myRole?: Roles
}

export enum CustomizationStatus {
  UnderConstruction = "UnderConstruction",
  Complete = "Complete",
  Published = "Published",
  Locked = "Locked"
}

export interface FCCustomizationCreateRequest extends FCCustomizationCombinedBase {}

export interface FCCustomization {
  id?: string | undefined
  currentVersion?: number
  name: string
  description?: string | undefined
  createdAt?: Date
  createdBy?: string | undefined
  modifiedAt?: Date
  modifiedBy?: string | undefined
  currentVersionStatus?: CustomizationStatus
  myRole?: Roles
}

export interface FCCustomizationUpdateRequest extends FCCustomizationCombinedBase {}

export interface SystemValueBase {
  id?: string | undefined
  _etag?: string | undefined
}

export interface ProgressTicketBase extends SystemValueBase {
  _ts?: number
  /** Status of the process. */
  status?: ProcessStatus
  /** Short description of the process */
  description?: string | undefined
  /** Error messages that have occurred during the process. */
  errors?: ErrorMessage[] | undefined
  /** Total progress of the process in percent (0-100). */
  progress?: number
  /** Time to live in seconds. -1 means no expiration. */
  ttl?: number
}

/** Progress information for a feature catalog customization import. */
export interface FCCustomizationImportProgress extends ProgressTicketBase {
  /** ID of the FCC version that is being imported. */
  fccVersionId?: string | undefined
  /** Number of feature types that have been imported. */
  featureTypeCount?: number
  /** Number of property sets that have been imported. */
  pSetCount?: number
  /** Number of properties that have been imported. */
  propertyCount?: number
  /** Number of feature types that have been deleted. */
  deletedFeatureTypeCount?: number
  /** Number of property sets that have been deleted. */
  deletedPSetCount?: number
  /** Number of properties that have been deleted. */
  deletedPropertyCount?: number
  /** Time spent on the import process in milliseconds. */
  timeSpent?: number
}

/** Possible statuses for a process. */
export enum ProcessStatus {
  Running = "Running",
  Completed = "Completed",
  Failed = "Failed",
  Canceled = "Canceled"
}

export interface ErrorMessage {
  /** Key, attribute or field name that the error is related to. */
  key?: string | undefined
  /** The error message. */
  message?: string | undefined
}

export interface UserRole {
  userId?: string | undefined
  eMail: string
  name?: string | undefined
  role: Roles
}

export interface UserRoleCreateRequest {
  userId?: string | undefined
  eMail: string
  role: Roles
  /** URL to the front-end where the resource in question is shown */
  resourceUrl?: string | undefined
}

export interface UserRoleUpdateRequest {
  role: Roles
}

export interface ClassificationOfCategoryToAttributeConnectionExtended extends Classification {
  version?: string | undefined
  categories: CategoryToAttributeConnectionExtended[] | undefined
}

export interface ClassificationFullOfCategoryToAttributeConnectionExtended
  extends ClassificationOfCategoryToAttributeConnectionExtended {
  structure: ClassificationNode[] | undefined
}

export interface CategoryToAttributeConnection extends ClassificationCategory {
  codeAttributeTypeId?: number | undefined
  runningNumberAttributeTypeId?: number | undefined
}

export interface CategoryToAttributeConnectionExtended extends CategoryToAttributeConnection {
  description?: string | undefined
}

export interface ClassificationReference extends ClassificationHeader {
  version?: string | undefined
  categories: CategoryToAttributeConnection[] | undefined
}

export interface AttributeTypeGroup {
  id: number
  introducedInVersion: number
  name: string
  description?: string | undefined
  no?: number
}

export interface AttributeTypeGroupCreateRequest extends AttributeTypeGroupSimpleBase {}

export interface AttributeTypeGroupUpdateRequest extends AttributeTypeGroupSimpleBase {}

export interface AttributeTypeGroupUsage {
  /** True, if the property set (attribute type group) should apply to all feature types in the feature catalog; otherwise, false */
  applyToAllFeatureTypes?: boolean
  /** If ApplyToAllFeatureTypes is set, this value indicates in which version the apply
to all feature types was introduced. */
  applyToAllFeatureTypesIntroducedInVersion?: number | undefined
  /** Collection of feature types associated with the property set (attribute type group) */
  featureTypeReferences?: FeatureTypeReference[] | undefined
  /** Collection of feature type groups associated with the property set (attribute type group) */
  featureTypeGroupReferences?: FeatureTypeGroupReference[] | undefined
}

export interface FeatureTypeReference extends FeatureTypeReferenceSimple {
  introducedInVersion?: number
}

export interface FeatureTypeGroupReference {
  featureTypeGroupId: number
  featureTypeGroupName?: string | undefined
  introducedInVersion?: number
}

export interface AttributeTypeGroupUsageUpdateRequest {
  applyToAllFeatureTypes?: boolean
  featureTypeGroupIds?: number[] | undefined
  featureTypeIds?: number[] | undefined
}

export interface CustomAttributeType extends AttributeTypeExtended {
  introducedInVersion: number
}

export interface AttributeTypeUpdateRequest extends AttributeTypeSimpleBase {}

export interface LegalAttributeValueSimpleBase {
  value: string
  caption: string
  description?: string | undefined
  no?: number
}

export interface LegalValueCreateRequest extends LegalAttributeValueSimpleBase {}

export interface LegalValueUpdateRequest extends LegalAttributeValueSimpleBase {}

export interface CustomFeatureType extends FeatureTypeBase {
  /** Persistent ID for this feature type */
  id: number
  /** List of feature type groups that this feature type belongs to */
  groups?: CustomFeatureTypeGroupAffiliation[] | undefined
  /** In which version the feature catalog customization this feature type was added */
  introducedInVersion: number
}

export interface CustomFeatureTypeGroupAffiliation extends FeatureTypeGroupAffiliation {
  introducedInVersion?: number
}

export interface CustomFeatureTypeUpsertCsv {
  /** Persistent ID of the feature type.  */
  Id?: number
  FeatureTypeGroup?: string | undefined
  GeometryType?: string | undefined
  Description?: string | undefined
  No?: number
  SuperTypeId?: number | undefined
  IsAbstract?: boolean
  /** Name of the feature type */
  Name: string
}

/** Data for modifying a feature type */
export interface FeatureTypeUpdateRequest extends FeatureTypeSimple {}

export interface PublishFCAccepted {
  fcId: string | undefined
  name: string | undefined
  version: string | undefined
  publishProcessId: string | undefined
}

export interface TagCreateRequest {
  name: string
}

export interface PublishFCResourcesOk {
  fcId: string | undefined
  name: string | undefined
  version: string | undefined
  language: string | undefined
  languageDisplayName?: string | undefined
  uri: string | undefined
}

export interface PrivateFeatureCatalog extends FeatureCatalog {
  modifiedAt: Date
  modifiedBy: string | undefined
  createdAt: Date
  createdBy: string | undefined
  previousVersionId?: string | undefined
}

export interface FeatureCatalogStatusFailedRequest {
  /** Entity tag passed to the feature catalog generation function.
This tag has to match the current eTag of the feature catalog;
otherwise, the published info request will fail with a 409. */
  eTag: string
  reportUri?: string | undefined
  failedReason?: string | undefined
}

export interface PrivateFeatureCatalogStandard {
  id: string
  namespace: string
  standard: string
  featureCatalogName: string
  versions?: FeatureCatalogVersionReference[] | undefined
  currentVersion?: number
  tags?: Tag[] | undefined
  myRole?: Roles
}

export interface FeatureCatalogVersionReference {
  id: string
  version: number
  status?: FeatureCatalogStatus
}

export interface PrivateFeatureCatalogStandardCreateRequest {
  featureCatalogName: string
  standard: string
  tags?: string[] | undefined
}

export interface FileParameter {
  data: any
  fileName: string
}

export interface FileResponse {
  data: Blob
  status: number
  fileName?: string
  headers?: { [name: string]: any }
}

export class SwaggerException extends Error {
  message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isSwaggerException = true

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result
  else throw new SwaggerException(message, status, response, headers, null)
}
